/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIAQGUploadRequest,
  APIAddress,
  APIAddressRequest,
  APIArticle,
  APIArticleFile,
  APIArticleFileSearchResponse,
  APIArticleRequest,
  APIArticleSearchResponse,
  APIAutocompleteResponse,
  APIBOM,
  APIBOMRequest,
  APIBarcodeType,
  APIBarcodeTypeRequest,
  APIBill,
  APIBillAutocompleteResponse,
  APIBillFile,
  APIBillFileSearchResponse,
  APIBillRequest,
  APIBillSearchResponse,
  APIBomTreeResponse,
  APIBrand,
  APIBrandRequest,
  APICategory,
  APICategoryRequest,
  APIChangePasswordRequest,
  APIChannel,
  APIChannelRequest,
  APIContact,
  APIContactAutocompleteResponse,
  APIContactGroupView,
  APIContactGroupViewRequest,
  APIContactRequest,
  APIContactSearchResponse,
  APIContract,
  APIContractAutocompleteResponse,
  APIContractFile,
  APIContractFileSearchResponse,
  APIContractRequest,
  APIContractSearchResponse,
  APICustomerAutocompleteResponse,
  APICustomerSearchResponse,
  APIEmployeeAutocompleteResponse,
  APIEmployeeSearchResponse,
  APIFamily,
  APIFamilyRequest,
  APIGuestRequestAutocompleteResponse,
  APIGuestRequestFileSearchResponse,
  APIGuestRequestSearchResponse,
  APIGuestUser,
  APIInventoryMovement,
  APIInventoryMovementRequest,
  APIMarkReadRequestRequest,
  APIMarkReadResponse,
  APIMaterial,
  APIMaterialRequest,
  APIMessageAutocompleteResponse,
  APIMessageSearchResponse,
  APINamedAutocompleteResponse,
  APIOffer,
  APIOfferFile,
  APIOfferFileSearchResponse,
  APIOfferRequest,
  APIOfferSearchResponse,
  APIOrgUserTokenObtainPairRequest,
  APIOrganization,
  APIOrganizationAutocompleteResponse,
  APIOrganizationRequest,
  APIOrganizationSearchResponse,
  APIPart,
  APIPartEstimatedPrice,
  APIPartEstimatedPriceRequest,
  APIPartRequest,
  APIPatchedAddressRequest,
  APIPatchedArticleRequest,
  APIPatchedBOMRequest,
  APIPatchedBarcodeTypeRequest,
  APIPatchedBillRequest,
  APIPatchedBrandRequest,
  APIPatchedCategoryRequest,
  APIPatchedChangePasswordRequest,
  APIPatchedChannelRequest,
  APIPatchedContactRequest,
  APIPatchedContractRequest,
  APIPatchedFamilyRequest,
  APIPatchedInventoryMovementRequest,
  APIPatchedMaterialRequest,
  APIPatchedOfferRequest,
  APIPatchedOrganizationRequest,
  APIPatchedPartRequest,
  APIPatchedPropertyRequest,
  APIPatchedRequestRequest,
  APIPatchedRichContactRequest,
  APIPatchedStorageArticleRequest,
  APIPatchedStoragePositionRequest,
  APIPatchedTicketRequest,
  APIPatchedTypeRequest,
  APIPatchedWasteRequest,
  APIProperty,
  APIPropertyRequest,
  APIRegister,
  APIRegisterRequest,
  APIRequest,
  APIRequestAutocompleteResponse,
  APIRequestFile,
  APIRequestFileSearchResponse,
  APIRequestRequest,
  APIRequestSearchResponse,
  APIRichContact,
  APIRichContactRequest,
  APIRoleAutocompleteResponse,
  APIRoleSearchResponse,
  APISharepoint,
  APIStorageArticle,
  APIStorageArticleAutocompleteResponse,
  APIStorageArticleRequest,
  APIStorageArticleSearchResponse,
  APIStoragePosition,
  APIStoragePositionRequest,
  APISupplierAutocompleteResponse,
  APISupplierSearchResponse,
  APITicket,
  APITicketAutocompleteResponse,
  APITicketRequest,
  APITicketSearchResponse,
  APITokenRefresh,
  APITokenRefreshRequest,
  APITokenVerifyRequest,
  APIType,
  APITypeRequest,
  APIUnreadOverview,
  APIUserAutocompleteResponse,
  APIUserSearchResponse,
  APIWaste,
  APIWasteRequest,
} from '../models/index';
import {
    APIAQGUploadRequestFromJSON,
    APIAQGUploadRequestToJSON,
    APIAddressFromJSON,
    APIAddressToJSON,
    APIAddressRequestFromJSON,
    APIAddressRequestToJSON,
    APIArticleFromJSON,
    APIArticleToJSON,
    APIArticleFileFromJSON,
    APIArticleFileToJSON,
    APIArticleFileSearchResponseFromJSON,
    APIArticleFileSearchResponseToJSON,
    APIArticleRequestFromJSON,
    APIArticleRequestToJSON,
    APIArticleSearchResponseFromJSON,
    APIArticleSearchResponseToJSON,
    APIAutocompleteResponseFromJSON,
    APIAutocompleteResponseToJSON,
    APIBOMFromJSON,
    APIBOMToJSON,
    APIBOMRequestFromJSON,
    APIBOMRequestToJSON,
    APIBarcodeTypeFromJSON,
    APIBarcodeTypeToJSON,
    APIBarcodeTypeRequestFromJSON,
    APIBarcodeTypeRequestToJSON,
    APIBillFromJSON,
    APIBillToJSON,
    APIBillAutocompleteResponseFromJSON,
    APIBillAutocompleteResponseToJSON,
    APIBillFileFromJSON,
    APIBillFileToJSON,
    APIBillFileSearchResponseFromJSON,
    APIBillFileSearchResponseToJSON,
    APIBillRequestFromJSON,
    APIBillRequestToJSON,
    APIBillSearchResponseFromJSON,
    APIBillSearchResponseToJSON,
    APIBomTreeResponseFromJSON,
    APIBomTreeResponseToJSON,
    APIBrandFromJSON,
    APIBrandToJSON,
    APIBrandRequestFromJSON,
    APIBrandRequestToJSON,
    APICategoryFromJSON,
    APICategoryToJSON,
    APICategoryRequestFromJSON,
    APICategoryRequestToJSON,
    APIChangePasswordRequestFromJSON,
    APIChangePasswordRequestToJSON,
    APIChannelFromJSON,
    APIChannelToJSON,
    APIChannelRequestFromJSON,
    APIChannelRequestToJSON,
    APIContactFromJSON,
    APIContactToJSON,
    APIContactAutocompleteResponseFromJSON,
    APIContactAutocompleteResponseToJSON,
    APIContactGroupViewFromJSON,
    APIContactGroupViewToJSON,
    APIContactGroupViewRequestFromJSON,
    APIContactGroupViewRequestToJSON,
    APIContactRequestFromJSON,
    APIContactRequestToJSON,
    APIContactSearchResponseFromJSON,
    APIContactSearchResponseToJSON,
    APIContractFromJSON,
    APIContractToJSON,
    APIContractAutocompleteResponseFromJSON,
    APIContractAutocompleteResponseToJSON,
    APIContractFileFromJSON,
    APIContractFileToJSON,
    APIContractFileSearchResponseFromJSON,
    APIContractFileSearchResponseToJSON,
    APIContractRequestFromJSON,
    APIContractRequestToJSON,
    APIContractSearchResponseFromJSON,
    APIContractSearchResponseToJSON,
    APICustomerAutocompleteResponseFromJSON,
    APICustomerAutocompleteResponseToJSON,
    APICustomerSearchResponseFromJSON,
    APICustomerSearchResponseToJSON,
    APIEmployeeAutocompleteResponseFromJSON,
    APIEmployeeAutocompleteResponseToJSON,
    APIEmployeeSearchResponseFromJSON,
    APIEmployeeSearchResponseToJSON,
    APIFamilyFromJSON,
    APIFamilyToJSON,
    APIFamilyRequestFromJSON,
    APIFamilyRequestToJSON,
    APIGuestRequestAutocompleteResponseFromJSON,
    APIGuestRequestAutocompleteResponseToJSON,
    APIGuestRequestFileSearchResponseFromJSON,
    APIGuestRequestFileSearchResponseToJSON,
    APIGuestRequestSearchResponseFromJSON,
    APIGuestRequestSearchResponseToJSON,
    APIGuestUserFromJSON,
    APIGuestUserToJSON,
    APIInventoryMovementFromJSON,
    APIInventoryMovementToJSON,
    APIInventoryMovementRequestFromJSON,
    APIInventoryMovementRequestToJSON,
    APIMarkReadRequestRequestFromJSON,
    APIMarkReadRequestRequestToJSON,
    APIMarkReadResponseFromJSON,
    APIMarkReadResponseToJSON,
    APIMaterialFromJSON,
    APIMaterialToJSON,
    APIMaterialRequestFromJSON,
    APIMaterialRequestToJSON,
    APIMessageAutocompleteResponseFromJSON,
    APIMessageAutocompleteResponseToJSON,
    APIMessageSearchResponseFromJSON,
    APIMessageSearchResponseToJSON,
    APINamedAutocompleteResponseFromJSON,
    APINamedAutocompleteResponseToJSON,
    APIOfferFromJSON,
    APIOfferToJSON,
    APIOfferFileFromJSON,
    APIOfferFileToJSON,
    APIOfferFileSearchResponseFromJSON,
    APIOfferFileSearchResponseToJSON,
    APIOfferRequestFromJSON,
    APIOfferRequestToJSON,
    APIOfferSearchResponseFromJSON,
    APIOfferSearchResponseToJSON,
    APIOrgUserTokenObtainPairRequestFromJSON,
    APIOrgUserTokenObtainPairRequestToJSON,
    APIOrganizationFromJSON,
    APIOrganizationToJSON,
    APIOrganizationAutocompleteResponseFromJSON,
    APIOrganizationAutocompleteResponseToJSON,
    APIOrganizationRequestFromJSON,
    APIOrganizationRequestToJSON,
    APIOrganizationSearchResponseFromJSON,
    APIOrganizationSearchResponseToJSON,
    APIPartFromJSON,
    APIPartToJSON,
    APIPartEstimatedPriceFromJSON,
    APIPartEstimatedPriceToJSON,
    APIPartEstimatedPriceRequestFromJSON,
    APIPartEstimatedPriceRequestToJSON,
    APIPartRequestFromJSON,
    APIPartRequestToJSON,
    APIPatchedAddressRequestFromJSON,
    APIPatchedAddressRequestToJSON,
    APIPatchedArticleRequestFromJSON,
    APIPatchedArticleRequestToJSON,
    APIPatchedBOMRequestFromJSON,
    APIPatchedBOMRequestToJSON,
    APIPatchedBarcodeTypeRequestFromJSON,
    APIPatchedBarcodeTypeRequestToJSON,
    APIPatchedBillRequestFromJSON,
    APIPatchedBillRequestToJSON,
    APIPatchedBrandRequestFromJSON,
    APIPatchedBrandRequestToJSON,
    APIPatchedCategoryRequestFromJSON,
    APIPatchedCategoryRequestToJSON,
    APIPatchedChangePasswordRequestFromJSON,
    APIPatchedChangePasswordRequestToJSON,
    APIPatchedChannelRequestFromJSON,
    APIPatchedChannelRequestToJSON,
    APIPatchedContactRequestFromJSON,
    APIPatchedContactRequestToJSON,
    APIPatchedContractRequestFromJSON,
    APIPatchedContractRequestToJSON,
    APIPatchedFamilyRequestFromJSON,
    APIPatchedFamilyRequestToJSON,
    APIPatchedInventoryMovementRequestFromJSON,
    APIPatchedInventoryMovementRequestToJSON,
    APIPatchedMaterialRequestFromJSON,
    APIPatchedMaterialRequestToJSON,
    APIPatchedOfferRequestFromJSON,
    APIPatchedOfferRequestToJSON,
    APIPatchedOrganizationRequestFromJSON,
    APIPatchedOrganizationRequestToJSON,
    APIPatchedPartRequestFromJSON,
    APIPatchedPartRequestToJSON,
    APIPatchedPropertyRequestFromJSON,
    APIPatchedPropertyRequestToJSON,
    APIPatchedRequestRequestFromJSON,
    APIPatchedRequestRequestToJSON,
    APIPatchedRichContactRequestFromJSON,
    APIPatchedRichContactRequestToJSON,
    APIPatchedStorageArticleRequestFromJSON,
    APIPatchedStorageArticleRequestToJSON,
    APIPatchedStoragePositionRequestFromJSON,
    APIPatchedStoragePositionRequestToJSON,
    APIPatchedTicketRequestFromJSON,
    APIPatchedTicketRequestToJSON,
    APIPatchedTypeRequestFromJSON,
    APIPatchedTypeRequestToJSON,
    APIPatchedWasteRequestFromJSON,
    APIPatchedWasteRequestToJSON,
    APIPropertyFromJSON,
    APIPropertyToJSON,
    APIPropertyRequestFromJSON,
    APIPropertyRequestToJSON,
    APIRegisterFromJSON,
    APIRegisterToJSON,
    APIRegisterRequestFromJSON,
    APIRegisterRequestToJSON,
    APIRequestFromJSON,
    APIRequestToJSON,
    APIRequestAutocompleteResponseFromJSON,
    APIRequestAutocompleteResponseToJSON,
    APIRequestFileFromJSON,
    APIRequestFileToJSON,
    APIRequestFileSearchResponseFromJSON,
    APIRequestFileSearchResponseToJSON,
    APIRequestRequestFromJSON,
    APIRequestRequestToJSON,
    APIRequestSearchResponseFromJSON,
    APIRequestSearchResponseToJSON,
    APIRichContactFromJSON,
    APIRichContactToJSON,
    APIRichContactRequestFromJSON,
    APIRichContactRequestToJSON,
    APIRoleAutocompleteResponseFromJSON,
    APIRoleAutocompleteResponseToJSON,
    APIRoleSearchResponseFromJSON,
    APIRoleSearchResponseToJSON,
    APISharepointFromJSON,
    APISharepointToJSON,
    APIStorageArticleFromJSON,
    APIStorageArticleToJSON,
    APIStorageArticleAutocompleteResponseFromJSON,
    APIStorageArticleAutocompleteResponseToJSON,
    APIStorageArticleRequestFromJSON,
    APIStorageArticleRequestToJSON,
    APIStorageArticleSearchResponseFromJSON,
    APIStorageArticleSearchResponseToJSON,
    APIStoragePositionFromJSON,
    APIStoragePositionToJSON,
    APIStoragePositionRequestFromJSON,
    APIStoragePositionRequestToJSON,
    APISupplierAutocompleteResponseFromJSON,
    APISupplierAutocompleteResponseToJSON,
    APISupplierSearchResponseFromJSON,
    APISupplierSearchResponseToJSON,
    APITicketFromJSON,
    APITicketToJSON,
    APITicketAutocompleteResponseFromJSON,
    APITicketAutocompleteResponseToJSON,
    APITicketRequestFromJSON,
    APITicketRequestToJSON,
    APITicketSearchResponseFromJSON,
    APITicketSearchResponseToJSON,
    APITokenRefreshFromJSON,
    APITokenRefreshToJSON,
    APITokenRefreshRequestFromJSON,
    APITokenRefreshRequestToJSON,
    APITokenVerifyRequestFromJSON,
    APITokenVerifyRequestToJSON,
    APITypeFromJSON,
    APITypeToJSON,
    APITypeRequestFromJSON,
    APITypeRequestToJSON,
    APIUnreadOverviewFromJSON,
    APIUnreadOverviewToJSON,
    APIUserAutocompleteResponseFromJSON,
    APIUserAutocompleteResponseToJSON,
    APIUserSearchResponseFromJSON,
    APIUserSearchResponseToJSON,
    APIWasteFromJSON,
    APIWasteToJSON,
    APIWasteRequestFromJSON,
    APIWasteRequestToJSON,
} from '../models/index';

export interface V1AccountsRegisterCreateRequest {
    aPIRegisterRequest: APIRegisterRequest;
}

export interface V1AuthChangePasswordPartialUpdateRequest {
    aPIPatchedChangePasswordRequest?: APIPatchedChangePasswordRequest;
}

export interface V1AuthChangePasswordUpdateRequest {
    aPIChangePasswordRequest: APIChangePasswordRequest;
}

export interface V1AuthTokenCreateRequest {
    aPIOrgUserTokenObtainPairRequest: APIOrgUserTokenObtainPairRequest;
}

export interface V1AuthTokenRefreshCreateRequest {
    aPITokenRefreshRequest: APITokenRefreshRequest;
}

export interface V1AuthTokenVerifyCreateRequest {
    aPITokenVerifyRequest: APITokenVerifyRequest;
}

export interface V1ChatChannelInteractedPartialUpdateRequest {
    id: string;
    aPIPatchedChannelRequest?: APIPatchedChannelRequest;
}

export interface V1ChatChannelLeaveChannelCreateRequest {
    id: string;
    aPIChannelRequest: APIChannelRequest;
}

export interface V1ContactsAddressesCompareVersionsCreateRequest {
    id: number;
    aPIAddressRequest: APIAddressRequest;
}

export interface V1ContactsAddressesRevertPartialUpdateRequest {
    id: number;
    aPIPatchedAddressRequest?: APIPatchedAddressRequest;
}

export interface V1ContactsAddressesVersionsRetrieveRequest {
    id: number;
}

export interface V1ContactsContactGroupsAddContactsCreateRequest {
    id: number;
    aPIContactGroupViewRequest: APIContactGroupViewRequest;
}

export interface V1ContactsContactsAddressesCompareVersionsCreateRequest {
    contactsPk: string;
    id: number;
    aPIAddressRequest: APIAddressRequest;
}

export interface V1ContactsContactsAddressesRevertPartialUpdateRequest {
    contactsPk: string;
    id: number;
    aPIPatchedAddressRequest?: APIPatchedAddressRequest;
}

export interface V1ContactsContactsAddressesVersionsRetrieveRequest {
    contactsPk: string;
    id: number;
}

export interface V1ContactsContactsCompareVersionsCreateRequest {
    id: number;
    aPIContactRequest: APIContactRequest;
}

export interface V1ContactsContactsGroupsAddContactsCreateRequest {
    contactsPk: string;
    id: number;
    aPIContactGroupViewRequest: APIContactGroupViewRequest;
}

export interface V1ContactsContactsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedContactRequest?: APIPatchedContactRequest;
}

export interface V1ContactsContactsVersionsRetrieveRequest {
    id: number;
}

export interface V1ContactsRichContactsCompareVersionsCreateRequest {
    id: number;
    aPIRichContactRequest: APIRichContactRequest;
}

export interface V1ContactsRichContactsCreateRequest {
    aPIRichContactRequest: APIRichContactRequest;
}

export interface V1ContactsRichContactsDestroyRequest {
    id: number;
}

export interface V1ContactsRichContactsPartialUpdateRequest {
    id: number;
    aPIPatchedRichContactRequest?: APIPatchedRichContactRequest;
}

export interface V1ContactsRichContactsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedRichContactRequest?: APIPatchedRichContactRequest;
}

export interface V1ContactsRichContactsUpdateRequest {
    id: number;
    aPIRichContactRequest: APIRichContactRequest;
}

export interface V1ContactsRichContactsVersionsRetrieveRequest {
    id: number;
}

export interface V1ContractBillFilesCompareVersionsCreateRequest {
    id: number;
    bill: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ContractBillFilesRevertPartialUpdateRequest {
    id: number;
    bill?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ContractBillFilesVersionsRetrieveRequest {
    id: number;
}

export interface V1ContractBillsCompareVersionsCreateRequest {
    id: number;
    aPIBillRequest: APIBillRequest;
}

export interface V1ContractBillsFilesCompareVersionsCreateRequest {
    billPk: number;
    id: number;
    bill: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ContractBillsFilesRevertPartialUpdateRequest {
    billPk: number;
    id: number;
    bill?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ContractBillsFilesVersionsRetrieveRequest {
    billPk: number;
    id: number;
}

export interface V1ContractBillsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedBillRequest?: APIPatchedBillRequest;
}

export interface V1ContractBillsVersionsRetrieveRequest {
    id: number;
}

export interface V1ContractContractsCompareVersionsCreateRequest {
    id: number;
    aPIContractRequest: APIContractRequest;
}

export interface V1ContractContractsFilesCompareVersionsCreateRequest {
    contractPk: number;
    id: number;
    contract: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ContractContractsFilesRevertPartialUpdateRequest {
    contractPk: number;
    id: number;
    contract?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ContractContractsFilesVersionsRetrieveRequest {
    contractPk: number;
    id: number;
}

export interface V1ContractContractsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedContractRequest?: APIPatchedContractRequest;
}

export interface V1ContractContractsVersionsRetrieveRequest {
    id: number;
}

export interface V1ContractFilesCompareVersionsCreateRequest {
    id: number;
    contract: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ContractFilesRevertPartialUpdateRequest {
    id: number;
    contract?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ContractFilesVersionsRetrieveRequest {
    id: number;
}

export interface V1CustomerCustomersAddressesCompareVersionsCreateRequest {
    customersPk: string;
    id: number;
    aPIAddressRequest: APIAddressRequest;
}

export interface V1CustomerCustomersAddressesRevertPartialUpdateRequest {
    customersPk: string;
    id: number;
    aPIPatchedAddressRequest?: APIPatchedAddressRequest;
}

export interface V1CustomerCustomersAddressesVersionsRetrieveRequest {
    customersPk: string;
    id: number;
}

export interface V1GeneralFilesDestroyRequest {
    fileName: string;
}

export interface V1ItemsArticlesAllowedBomChildrenRetrieveRequest {
    id: number;
}

export interface V1ItemsArticlesAncestorsRetrieveRequest {
    id: number;
}

export interface V1ItemsArticlesBomCompareVersionsCreateRequest {
    articlePk: string;
    id: number;
    aPIBOMRequest: APIBOMRequest;
}

export interface V1ItemsArticlesBomRevertPartialUpdateRequest {
    articlePk: string;
    id: number;
    aPIPatchedBOMRequest?: APIPatchedBOMRequest;
}

export interface V1ItemsArticlesBomVersionsRetrieveRequest {
    articlePk: string;
    id: number;
}

export interface V1ItemsArticlesCategoriesCompareVersionsCreateRequest {
    articlePk: string;
    id: number;
    aPICategoryRequest: APICategoryRequest;
}

export interface V1ItemsArticlesCategoriesRevertPartialUpdateRequest {
    articlePk: string;
    id: number;
    aPIPatchedCategoryRequest?: APIPatchedCategoryRequest;
}

export interface V1ItemsArticlesCategoriesVersionsRetrieveRequest {
    articlePk: string;
    id: number;
}

export interface V1ItemsArticlesCompareVersionsCreateRequest {
    id: number;
    aPIArticleRequest: APIArticleRequest;
}

export interface V1ItemsArticlesFilesCompareVersionsCreateRequest {
    articlePk: number;
    id: number;
    article: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ItemsArticlesFilesConvertScsCreateRequest {
    articlePk: number;
    id: number;
    article: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ItemsArticlesFilesRevertPartialUpdateRequest {
    articlePk: number;
    id: number;
    article?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ItemsArticlesFilesVersionsRetrieveRequest {
    articlePk: number;
    id: number;
}

export interface V1ItemsArticlesPropertiesCompareVersionsCreateRequest {
    articlePk: string;
    id: number;
    aPIPropertyRequest: APIPropertyRequest;
}

export interface V1ItemsArticlesPropertiesRevertPartialUpdateRequest {
    articlePk: string;
    id: number;
    aPIPatchedPropertyRequest?: APIPatchedPropertyRequest;
}

export interface V1ItemsArticlesPropertiesVersionsRetrieveRequest {
    articlePk: string;
    id: number;
}

export interface V1ItemsArticlesRequestsCompareVersionsCreateRequest {
    articlePk: string;
    id: number;
    aPIRequestRequest: APIRequestRequest;
}

export interface V1ItemsArticlesRequestsCompletePartialUpdateRequest {
    articlePk: string;
    id: number;
    aPIPatchedRequestRequest?: APIPatchedRequestRequest;
}

export interface V1ItemsArticlesRequestsProcessingStatusCreateRequest {
    articlePk: string;
    id: number;
    aPIRequestRequest: APIRequestRequest;
}

export interface V1ItemsArticlesRequestsRevertPartialUpdateRequest {
    articlePk: string;
    id: number;
    aPIPatchedRequestRequest?: APIPatchedRequestRequest;
}

export interface V1ItemsArticlesRequestsVersionsRetrieveRequest {
    articlePk: string;
    id: number;
}

export interface V1ItemsArticlesRevertPartialUpdateRequest {
    id: number;
    aPIPatchedArticleRequest?: APIPatchedArticleRequest;
}

export interface V1ItemsArticlesVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsBarcodeTypesCompareVersionsCreateRequest {
    id: number;
    aPIBarcodeTypeRequest: APIBarcodeTypeRequest;
}

export interface V1ItemsBarcodeTypesRevertPartialUpdateRequest {
    id: number;
    aPIPatchedBarcodeTypeRequest?: APIPatchedBarcodeTypeRequest;
}

export interface V1ItemsBarcodeTypesVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsBomBasesCompareVersionsCreateRequest {
    id: number;
    aPIArticleRequest: APIArticleRequest;
}

export interface V1ItemsBomBasesRevertPartialUpdateRequest {
    id: number;
    aPIPatchedArticleRequest?: APIPatchedArticleRequest;
}

export interface V1ItemsBomBasesVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsBomsCompareVersionsCreateRequest {
    id: number;
    aPIBOMRequest: APIBOMRequest;
}

export interface V1ItemsBomsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedBOMRequest?: APIPatchedBOMRequest;
}

export interface V1ItemsBomsVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsBrandsCompareVersionsCreateRequest {
    id: number;
    aPIBrandRequest: APIBrandRequest;
}

export interface V1ItemsBrandsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedBrandRequest?: APIPatchedBrandRequest;
}

export interface V1ItemsBrandsVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsCategoriesCompareVersionsCreateRequest {
    id: number;
    aPICategoryRequest: APICategoryRequest;
}

export interface V1ItemsCategoriesRevertPartialUpdateRequest {
    id: number;
    aPIPatchedCategoryRequest?: APIPatchedCategoryRequest;
}

export interface V1ItemsCategoriesVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsFamiliesCompareVersionsCreateRequest {
    id: number;
    aPIFamilyRequest: APIFamilyRequest;
}

export interface V1ItemsFamiliesRevertPartialUpdateRequest {
    id: number;
    aPIPatchedFamilyRequest?: APIPatchedFamilyRequest;
}

export interface V1ItemsFamiliesVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsFilesCompareVersionsCreateRequest {
    id: number;
    article: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ItemsFilesConvertScsCreateRequest {
    id: number;
    article: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ItemsFilesRevertPartialUpdateRequest {
    id: number;
    article?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1ItemsFilesVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsMaterialsCompareVersionsCreateRequest {
    id: number;
    aPIMaterialRequest: APIMaterialRequest;
}

export interface V1ItemsMaterialsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedMaterialRequest?: APIPatchedMaterialRequest;
}

export interface V1ItemsMaterialsVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsPropertiesCompareVersionsCreateRequest {
    id: number;
    aPIPropertyRequest: APIPropertyRequest;
}

export interface V1ItemsPropertiesRevertPartialUpdateRequest {
    id: number;
    aPIPatchedPropertyRequest?: APIPatchedPropertyRequest;
}

export interface V1ItemsPropertiesVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsSharepointsAutomaticSharesRetrieveRequest {
    id: number;
}

export interface V1ItemsSharepointsManualSharesRetrieveRequest {
    id: number;
}

export interface V1ItemsTypesCompareVersionsCreateRequest {
    id: number;
    aPITypeRequest: APITypeRequest;
}

export interface V1ItemsTypesRevertPartialUpdateRequest {
    id: number;
    aPIPatchedTypeRequest?: APIPatchedTypeRequest;
}

export interface V1ItemsTypesVersionsRetrieveRequest {
    id: number;
}

export interface V1ItemsWasteCompareVersionsCreateRequest {
    id: number;
    aPIWasteRequest: APIWasteRequest;
}

export interface V1ItemsWasteRevertPartialUpdateRequest {
    id: number;
    aPIPatchedWasteRequest?: APIPatchedWasteRequest;
}

export interface V1ItemsWasteVersionsRetrieveRequest {
    id: number;
}

export interface V1LogisticsInventoryMovementsCompareVersionsCreateRequest {
    id: number;
    aPIInventoryMovementRequest: APIInventoryMovementRequest;
}

export interface V1LogisticsInventoryMovementsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedInventoryMovementRequest?: APIPatchedInventoryMovementRequest;
}

export interface V1LogisticsInventoryMovementsVersionsRetrieveRequest {
    id: number;
}

export interface V1LogisticsStorageArticlesCompareVersionsCreateRequest {
    id: number;
    aPIStorageArticleRequest: APIStorageArticleRequest;
}

export interface V1LogisticsStorageArticlesRelocateCreateRequest {
    id: number;
    aPIStorageArticleRequest: APIStorageArticleRequest;
}

export interface V1LogisticsStorageArticlesRevertPartialUpdateRequest {
    id: number;
    aPIPatchedStorageArticleRequest?: APIPatchedStorageArticleRequest;
}

export interface V1LogisticsStorageArticlesStoreCreateRequest {
    aPIStorageArticleRequest: APIStorageArticleRequest;
}

export interface V1LogisticsStorageArticlesVersionsRetrieveRequest {
    id: number;
}

export interface V1LogisticsStorageArticlesWithdrawCreateRequest {
    id: number;
    aPIStorageArticleRequest: APIStorageArticleRequest;
}

export interface V1LogisticsStoragePositionsCompareVersionsCreateRequest {
    id: number;
    aPIStoragePositionRequest: APIStoragePositionRequest;
}

export interface V1LogisticsStoragePositionsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedStoragePositionRequest?: APIPatchedStoragePositionRequest;
}

export interface V1LogisticsStoragePositionsVersionsRetrieveRequest {
    id: number;
}

export interface V1OrganizationsOrganizationBillingAddressCompareVersionsCreateRequest {
    id: number;
    organizationPk: string;
    aPIAddressRequest: APIAddressRequest;
}

export interface V1OrganizationsOrganizationBillingAddressRevertPartialUpdateRequest {
    id: number;
    organizationPk: string;
    aPIPatchedAddressRequest?: APIPatchedAddressRequest;
}

export interface V1OrganizationsOrganizationBillingAddressVersionsRetrieveRequest {
    id: number;
    organizationPk: string;
}

export interface V1OrganizationsOrganizationCompareVersionsCreateRequest {
    id: number;
    aPIOrganizationRequest: APIOrganizationRequest;
}

export interface V1OrganizationsOrganizationRevertPartialUpdateRequest {
    id: number;
    aPIPatchedOrganizationRequest?: APIPatchedOrganizationRequest;
}

export interface V1OrganizationsOrganizationShippingAddressCompareVersionsCreateRequest {
    id: number;
    organizationPk: string;
    aPIAddressRequest: APIAddressRequest;
}

export interface V1OrganizationsOrganizationShippingAddressRevertPartialUpdateRequest {
    id: number;
    organizationPk: string;
    aPIPatchedAddressRequest?: APIPatchedAddressRequest;
}

export interface V1OrganizationsOrganizationShippingAddressVersionsRetrieveRequest {
    id: number;
    organizationPk: string;
}

export interface V1OrganizationsOrganizationVersionsRetrieveRequest {
    id: number;
}

export interface V1RequestAqgUploadCreateRequest {
    aPIAQGUploadRequest: APIAQGUploadRequest;
}

export interface V1RequestFilesCompareVersionsCreateRequest {
    id: number;
    request: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestFilesRevertPartialUpdateRequest {
    id: number;
    request?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestFilesVersionsRetrieveRequest {
    id: number;
}

export interface V1RequestOfferFilesCompareVersionsCreateRequest {
    id: number;
    offer: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestOfferFilesRevertPartialUpdateRequest {
    id: number;
    offer?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestOfferFilesVersionsRetrieveRequest {
    id: number;
}

export interface V1RequestOffersCompareVersionsCreateRequest {
    id: number;
    aPIOfferRequest: APIOfferRequest;
}

export interface V1RequestOffersFilesCompareVersionsCreateRequest {
    id: number;
    offerPk: number;
    offer: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestOffersFilesRevertPartialUpdateRequest {
    id: number;
    offerPk: number;
    offer?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestOffersFilesVersionsRetrieveRequest {
    id: number;
    offerPk: number;
}

export interface V1RequestOffersRevertPartialUpdateRequest {
    id: number;
    aPIPatchedOfferRequest?: APIPatchedOfferRequest;
}

export interface V1RequestOffersVersionsRetrieveRequest {
    id: number;
}

export interface V1RequestRequestsBomItemsBulkCreateRequest {
    requestPk: number;
}

export interface V1RequestRequestsCompareVersionsCreateRequest {
    id: number;
    aPIRequestRequest: APIRequestRequest;
}

export interface V1RequestRequestsCompletePartialUpdateRequest {
    id: number;
    aPIPatchedRequestRequest?: APIPatchedRequestRequest;
}

export interface V1RequestRequestsFilesCompareVersionsCreateRequest {
    id: number;
    requestPk: number;
    request: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestRequestsFilesRevertPartialUpdateRequest {
    id: number;
    requestPk: number;
    request?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestRequestsFilesVersionsRetrieveRequest {
    id: number;
    requestPk: number;
}

export interface V1RequestRequestsPartsBulkPartialUpdateRequest {
    requestPk: string;
    aPIPatchedPartRequest?: APIPatchedPartRequest;
}

export interface V1RequestRequestsPartsChildrenRetrieveRequest {
    id: string;
    requestPk: string;
}

export interface V1RequestRequestsPartsPriceRetrieveRequest {
    id: string;
    requestPk: string;
}

export interface V1RequestRequestsPartsPriceUpdateRequest {
    id: string;
    requestPk: string;
    aPIPartEstimatedPriceRequest?: APIPartEstimatedPriceRequest;
}

export interface V1RequestRequestsPartsRecalculateCreateRequest {
    id: string;
    requestPk: string;
    aPIPartRequest: APIPartRequest;
}

export interface V1RequestRequestsPartsSingleRequestRetrieveRequest {
    id: string;
    requestPk: string;
}

export interface V1RequestRequestsProcessingStatusCreateRequest {
    id: number;
    aPIRequestRequest: APIRequestRequest;
}

export interface V1RequestRequestsRevertPartialUpdateRequest {
    id: number;
    aPIPatchedRequestRequest?: APIPatchedRequestRequest;
}

export interface V1RequestRequestsVersionsRetrieveRequest {
    id: number;
}

export interface V1SearchAccountsRolesAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchAccountsRolesRetrieveRequest {
    q: string;
    description?: string;
    fields?: string;
    from?: number;
    isGuestUserRole?: boolean;
    name?: string;
    size?: number;
    subRoleIds?: string;
    subRoleNames?: string;
}

export interface V1SearchAccountsUsersAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
    staffOnly?: boolean;
}

export interface V1SearchAccountsUsersRetrieveRequest {
    q: string;
    comment?: string;
    createdFrom?: string;
    createdTo?: string;
    email?: string;
    fields?: string;
    firstName?: string;
    from?: number;
    guestId?: string;
    guestRepForId?: number;
    guestSharepointId?: number;
    isActive?: boolean;
    isGuestUser?: boolean;
    isOrgAdmin?: boolean;
    isStaff?: boolean;
    language?: string;
    lastName?: string;
    roleIds?: string;
    roleNames?: string;
    rootAccountId?: string;
    size?: number;
    userType?: string;
}

export interface V1SearchChatMessagesAutocompleteRetrieveRequest {
    q: string;
    size?: number;
}

export interface V1SearchChatMessagesRetrieveRequest {
    q: string;
    authorEmail?: string;
    authorId?: string;
    authorTypes?: string;
    channelId?: number;
    channelName?: string;
    createdFrom?: string;
    createdTo?: string;
    fields?: string;
    from?: number;
    hasEvent?: boolean;
    messageType?: string;
    size?: number;
}

export interface V1SearchContactsAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchContactsRetrieveRequest {
    q: string;
    city?: string;
    comment?: string;
    country?: string;
    email?: string;
    fields?: string;
    from?: number;
    language?: string;
    mobile?: string;
    name?: string;
    phone?: string;
    preferredContactMethod?: number;
    size?: number;
}

export interface V1SearchContractsBillFilesRetrieveRequest {
    q: string;
    billId?: number;
    contractId?: number;
    fields?: string;
    fileName?: string;
    fileSize?: string;
    from?: number;
    requestCertificate?: string;
    requestId?: number;
    size?: number;
    storedAt?: Date;
}

export interface V1SearchContractsBillsAutocompleteRetrieveRequest {
    q: string;
    size?: number;
}

export interface V1SearchContractsBillsRetrieveRequest {
    q: string;
    amount?: number;
    amountMax?: number;
    amountMin?: number;
    billNumber?: string;
    contractNumber?: string;
    contractStatus?: string;
    createdAt?: string;
    dueDate?: Date;
    editorId?: string;
    editors?: string;
    fields?: string;
    from?: number;
    paid?: boolean;
    requestCertificate?: string;
    size?: number;
}

export interface V1SearchContractsContractFilesRetrieveRequest {
    q: string;
    contractId?: number;
    fields?: string;
    fileName?: string;
    fileSize?: string;
    from?: number;
    requestCertificate?: string;
    requestId?: number;
    size?: number;
    storedAt?: Date;
}

export interface V1SearchContractsContractsAutocompleteRetrieveRequest {
    q: string;
    size?: number;
}

export interface V1SearchContractsContractsRetrieveRequest {
    q: string;
    article?: string;
    articleNumber?: string;
    billingAddress?: string;
    comment?: string;
    contractNumber?: string;
    createdAt?: string;
    desiredDelivery?: Date;
    editorId?: string;
    editors?: string;
    fields?: string;
    from?: number;
    lastModifiedAt?: string;
    latestDelivery?: Date;
    offerId?: number;
    offerNumber?: string;
    organization?: string;
    price?: number;
    priorityShipping?: boolean;
    requestCertificate?: string;
    requestId?: number;
    requestStatus?: string;
    shippingAddress?: string;
    size?: number;
    status?: string;
}

export interface V1SearchCustomersCustomersAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchCustomersCustomersRetrieveRequest {
    q: string;
    contactEmail?: string;
    contactName?: string;
    fields?: string;
    from?: number;
    name?: string;
    size?: number;
    ustId?: string;
}

export interface V1SearchGuestRequestsGuestRequestFilesRetrieveRequest {
    q: string;
    createdAt?: Date;
    fields?: string;
    fileName?: string;
    fileSize?: string;
    fileType?: string;
    from?: number;
    guestRequestId?: number;
    size?: number;
}

export interface V1SearchGuestRequestsGuestRequestsAutocompleteRetrieveRequest {
    q: string;
    size?: number;
}

export interface V1SearchGuestRequestsGuestRequestsRetrieveRequest {
    q: string;
    company?: string;
    createdDate?: Date;
    description?: string;
    editors?: string;
    email?: string;
    fields?: string;
    from?: number;
    hasFiles?: boolean;
    isTemp?: boolean;
    material?: string;
    name?: string;
    phone?: string;
    quantity?: string;
    readById?: string;
    requestNumber?: string;
    size?: number;
    status?: string;
    updatedDate?: Date;
}

export interface V1SearchItemsArticleFilesRetrieveRequest {
    q: string;
    articleId?: number;
    articleName?: string;
    articleNumber?: string;
    fields?: string;
    fileName?: string;
    fileSize?: string;
    from?: number;
    size?: number;
    storedAt?: Date;
}

export interface V1SearchItemsArticleTypesAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchItemsArticlesAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchItemsArticlesBomSearchRetrieveRequest {
    bomBaseId: string;
    q: string;
    amount?: number;
    createdAt?: string;
    description?: string;
    manufacturingProcess?: string;
    name?: string;
    number?: string;
    size?: number;
}

export interface V1SearchItemsArticlesRetrieveRequest {
    q: string;
    barcode?: string;
    barcodeText?: string;
    barcodeType?: string;
    brand?: string;
    category?: string;
    countryOfOrigin?: string;
    createdAt?: string;
    description?: string;
    family?: string;
    fields?: string;
    from?: number;
    height?: number;
    isActive?: string;
    isBomBase?: boolean;
    length?: number;
    material?: string;
    name?: string;
    number?: string;
    organization?: string;
    properties?: string;
    requestId?: number;
    size?: number;
    supplier?: string;
    type?: string;
    variationOf?: string;
    volume?: number;
    weight?: number;
    width?: number;
}

export interface V1SearchItemsBarcodeTypesAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchItemsBrandsAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchItemsCategoriesAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchItemsFamiliesAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchItemsPropertiesAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchLogisticsStorageArticlesAutocompleteRetrieveRequest {
    q: string;
    size?: number;
}

export interface V1SearchLogisticsStorageArticlesRetrieveRequest {
    q: string;
    articleNumber?: string;
    fields?: string;
    from?: number;
    guestEmail?: string;
    guestRequestId?: number;
    maxAmount?: number;
    minAmount?: number;
    position?: string;
    sharedRequestId?: number;
    size?: number;
}

export interface V1SearchOrganizationsOrganizationsAutocompleteRetrieveRequest {
    q: string;
    size?: number;
}

export interface V1SearchOrganizationsOrganizationsRetrieveRequest {
    q: string;
    city?: string;
    country?: string;
    fields?: string;
    from?: number;
    hasBillingAddress?: boolean;
    rootAccountId?: string;
    shippingCity?: string;
    size?: number;
    vatNumber?: string;
}

export interface V1SearchPersonnelEmployeesAutocompleteRetrieveRequest {
    q: string;
    size?: number;
}

export interface V1SearchPersonnelEmployeesRetrieveRequest {
    q: string;
    fields?: string;
    from?: number;
    groupName?: string;
    hasUser?: boolean;
    positionName?: string;
    size?: number;
    userEmail?: string;
    userId?: string;
    weekday?: string;
    workShift?: string;
}

export interface V1SearchRequestsOfferFilesRetrieveRequest {
    q: string;
    fields?: string;
    fileName?: string;
    fileSize?: string;
    from?: number;
    offerId?: number;
    requestCertificate?: string;
    requestId?: number;
    size?: number;
    storedAt?: Date;
}

export interface V1SearchRequestsOffersRetrieveRequest {
    q: string;
    article?: string;
    articleNumber?: string;
    createdAt?: Date;
    editors?: string;
    fields?: string;
    from?: number;
    lastModifiedAt?: Date;
    offerNumber?: string;
    prices?: string;
    remarks?: string;
    requestNumber?: string;
    size?: number;
    status?: number;
}

export interface V1SearchRequestsRequestFilesRetrieveRequest {
    q: string;
    fields?: string;
    fileName?: string;
    fileSize?: string;
    from?: number;
    requestCertificate?: string;
    requestId?: number;
    size?: number;
    storedAt?: Date;
}

export interface V1SearchRequestsRequestsAutocompleteRetrieveRequest {
    q: string;
    size?: number;
}

export interface V1SearchRequestsRequestsRetrieveRequest {
    q: string;
    article?: string;
    articleNumber?: string;
    certificate?: string;
    contactEmail?: string;
    contactId?: number;
    country?: string;
    createdBy?: string;
    createdDate?: Date;
    description?: string;
    editors?: string;
    fields?: string;
    from?: number;
    isTemp?: boolean;
    organization?: string;
    priority?: boolean;
    quantities?: string;
    remarks?: string;
    requestNumber?: string;
    size?: number;
    status?: string;
    updatedDate?: Date;
    wishDate?: Date;
}

export interface V1SearchSuppliersSuppliersAutocompleteRetrieveRequest {
    q?: string;
    size?: number;
}

export interface V1SearchSuppliersSuppliersRetrieveRequest {
    q: string;
    contactEmail?: string;
    contactLanguage?: string;
    contactName?: string;
    contactPhone?: string;
    fields?: string;
    from?: number;
    name?: string;
    size?: number;
    ustId?: string;
}

export interface V1SearchSupportTicketsAutocompleteRetrieveRequest {
    q: string;
    size?: number;
}

export interface V1SearchSupportTicketsRetrieveRequest {
    q: string;
    createdFrom?: string;
    createdTo?: string;
    fields?: string;
    from?: number;
    shared?: boolean;
    size?: number;
    status?: string;
    type?: string;
    userEmail?: string;
    userId?: string;
}

export interface V1SearchUnreadMarkReadCreateRequest {
    aPIMarkReadRequestRequest: APIMarkReadRequestRequest;
}

export interface V1SupplierSuppliersAddressesCompareVersionsCreateRequest {
    id: number;
    suppliersPk: string;
    aPIAddressRequest: APIAddressRequest;
}

export interface V1SupplierSuppliersAddressesRevertPartialUpdateRequest {
    id: number;
    suppliersPk: string;
    aPIPatchedAddressRequest?: APIPatchedAddressRequest;
}

export interface V1SupplierSuppliersAddressesVersionsRetrieveRequest {
    id: number;
    suppliersPk: string;
}

export interface V1SupplierSuppliersArticlesRetrieveRequest {
    id: number;
}

export interface V1SupportTicketsCompareVersionsCreateRequest {
    id: string;
    aPITicketRequest: APITicketRequest;
}

export interface V1SupportTicketsRevertPartialUpdateRequest {
    id: string;
    aPIPatchedTicketRequest?: APIPatchedTicketRequest;
}

export interface V1SupportTicketsVersionsRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class V1Api extends runtime.BaseAPI {

    /**
     * An endpoint for new Organization registration.
     */
    async v1AccountsRegisterCreateRaw(requestParameters: V1AccountsRegisterCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRegister>> {
        if (requestParameters['aPIRegisterRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIRegisterRequest',
                'Required parameter "aPIRegisterRequest" was null or undefined when calling v1AccountsRegisterCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIRegisterRequestToJSON(requestParameters['aPIRegisterRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRegisterFromJSON(jsonValue));
    }

    /**
     * An endpoint for new Organization registration.
     */
    async v1AccountsRegisterCreate(requestParameters: V1AccountsRegisterCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRegister> {
        const response = await this.v1AccountsRegisterCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * An endpoint for changing password.
     */
    async v1AuthChangePasswordPartialUpdateRaw(requestParameters: V1AuthChangePasswordPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/auth/change_password`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedChangePasswordRequestToJSON(requestParameters['aPIPatchedChangePasswordRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * An endpoint for changing password.
     */
    async v1AuthChangePasswordPartialUpdate(requestParameters: V1AuthChangePasswordPartialUpdateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1AuthChangePasswordPartialUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * An endpoint for changing password.
     */
    async v1AuthChangePasswordUpdateRaw(requestParameters: V1AuthChangePasswordUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['aPIChangePasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIChangePasswordRequest',
                'Required parameter "aPIChangePasswordRequest" was null or undefined when calling v1AuthChangePasswordUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/auth/change_password`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIChangePasswordRequestToJSON(requestParameters['aPIChangePasswordRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * An endpoint for changing password.
     */
    async v1AuthChangePasswordUpdate(requestParameters: V1AuthChangePasswordUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1AuthChangePasswordUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Takes and handles a set of user credentials from different user types and returns an access and refresh JSON web token pair to prove the authenticity of those credentials.
     */
    async v1AuthTokenCreateRaw(requestParameters: V1AuthTokenCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['aPIOrgUserTokenObtainPairRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIOrgUserTokenObtainPairRequest',
                'Required parameter "aPIOrgUserTokenObtainPairRequest" was null or undefined when calling v1AuthTokenCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/auth/token/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIOrgUserTokenObtainPairRequestToJSON(requestParameters['aPIOrgUserTokenObtainPairRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Takes and handles a set of user credentials from different user types and returns an access and refresh JSON web token pair to prove the authenticity of those credentials.
     */
    async v1AuthTokenCreate(requestParameters: V1AuthTokenCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1AuthTokenCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */
    async v1AuthTokenRefreshCreateRaw(requestParameters: V1AuthTokenRefreshCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APITokenRefresh>> {
        if (requestParameters['aPITokenRefreshRequest'] == null) {
            throw new runtime.RequiredError(
                'aPITokenRefreshRequest',
                'Required parameter "aPITokenRefreshRequest" was null or undefined when calling v1AuthTokenRefreshCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/auth/token/refresh/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APITokenRefreshRequestToJSON(requestParameters['aPITokenRefreshRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APITokenRefreshFromJSON(jsonValue));
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */
    async v1AuthTokenRefreshCreate(requestParameters: V1AuthTokenRefreshCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APITokenRefresh> {
        const response = await this.v1AuthTokenRefreshCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */
    async v1AuthTokenVerifyCreateRaw(requestParameters: V1AuthTokenVerifyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['aPITokenVerifyRequest'] == null) {
            throw new runtime.RequiredError(
                'aPITokenVerifyRequest',
                'Required parameter "aPITokenVerifyRequest" was null or undefined when calling v1AuthTokenVerifyCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/auth/token/verify/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APITokenVerifyRequestToJSON(requestParameters['aPITokenVerifyRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */
    async v1AuthTokenVerifyCreate(requestParameters: V1AuthTokenVerifyCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1AuthTokenVerifyCreateRaw(requestParameters, initOverrides);
    }

    /**
     * update the last interacted time in the ChannelMembership
     */
    async v1ChatChannelInteractedPartialUpdateRaw(requestParameters: V1ChatChannelInteractedPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIChannel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ChatChannelInteractedPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{id}/interacted/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedChannelRequestToJSON(requestParameters['aPIPatchedChannelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIChannelFromJSON(jsonValue));
    }

    /**
     * update the last interacted time in the ChannelMembership
     */
    async v1ChatChannelInteractedPartialUpdate(requestParameters: V1ChatChannelInteractedPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIChannel> {
        const response = await this.v1ChatChannelInteractedPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove the requesting user from the members of the channel that is specified by the pk.
     */
    async v1ChatChannelLeaveChannelCreateRaw(requestParameters: V1ChatChannelLeaveChannelCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIChannel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ChatChannelLeaveChannelCreate().'
            );
        }

        if (requestParameters['aPIChannelRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIChannelRequest',
                'Required parameter "aPIChannelRequest" was null or undefined when calling v1ChatChannelLeaveChannelCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/{id}/leave_channel/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIChannelRequestToJSON(requestParameters['aPIChannelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIChannelFromJSON(jsonValue));
    }

    /**
     * Remove the requesting user from the members of the channel that is specified by the pk.
     */
    async v1ChatChannelLeaveChannelCreate(requestParameters: V1ChatChannelLeaveChannelCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIChannel> {
        const response = await this.v1ChatChannelLeaveChannelCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the sum of all unread messages for all channels based on the requesting user.
     */
    async v1ChatChannelUnreadMessagesCountRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIChannel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/chat/channel/unread_messages_count/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIChannelFromJSON(jsonValue));
    }

    /**
     * Returns the sum of all unread messages for all channels based on the requesting user.
     */
    async v1ChatChannelUnreadMessagesCountRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIChannel> {
        const response = await this.v1ChatChannelUnreadMessagesCountRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsAddressesCompareVersionsCreateRaw(requestParameters: V1ContactsAddressesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsAddressesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIAddressRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAddressRequest',
                'Required parameter "aPIAddressRequest" was null or undefined when calling v1ContactsAddressesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/addresses/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAddressRequestToJSON(requestParameters['aPIAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsAddressesCompareVersionsCreate(requestParameters: V1ContactsAddressesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1ContactsAddressesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsAddressesRevertPartialUpdateRaw(requestParameters: V1ContactsAddressesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsAddressesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/addresses/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedAddressRequestToJSON(requestParameters['aPIPatchedAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsAddressesRevertPartialUpdate(requestParameters: V1ContactsAddressesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1ContactsAddressesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsAddressesVersionsRetrieveRaw(requestParameters: V1ContactsAddressesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsAddressesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/addresses/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsAddressesVersionsRetrieve(requestParameters: V1ContactsAddressesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1ContactsAddressesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a list of contacts to a contact group.
     */
    async v1ContactsContactGroupsAddContactsCreateRaw(requestParameters: V1ContactsContactGroupsAddContactsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupView>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactGroupsAddContactsCreate().'
            );
        }

        if (requestParameters['aPIContactGroupViewRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIContactGroupViewRequest',
                'Required parameter "aPIContactGroupViewRequest" was null or undefined when calling v1ContactsContactGroupsAddContactsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contact_groups/{id}/add_contacts/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIContactGroupViewRequestToJSON(requestParameters['aPIContactGroupViewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupViewFromJSON(jsonValue));
    }

    /**
     * Add a list of contacts to a contact group.
     */
    async v1ContactsContactGroupsAddContactsCreate(requestParameters: V1ContactsContactGroupsAddContactsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupView> {
        const response = await this.v1ContactsContactGroupsAddContactsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsAddressesCompareVersionsCreateRaw(requestParameters: V1ContactsContactsAddressesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsAddressesCompareVersionsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsAddressesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIAddressRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAddressRequest',
                'Required parameter "aPIAddressRequest" was null or undefined when calling v1ContactsContactsAddressesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/addresses/{id}/compare_versions/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAddressRequestToJSON(requestParameters['aPIAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsAddressesCompareVersionsCreate(requestParameters: V1ContactsContactsAddressesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1ContactsContactsAddressesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsAddressesRevertPartialUpdateRaw(requestParameters: V1ContactsContactsAddressesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsAddressesRevertPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsAddressesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/addresses/{id}/revert/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedAddressRequestToJSON(requestParameters['aPIPatchedAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsAddressesRevertPartialUpdate(requestParameters: V1ContactsContactsAddressesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1ContactsContactsAddressesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsAddressesVersionsRetrieveRaw(requestParameters: V1ContactsContactsAddressesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsAddressesVersionsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsAddressesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/addresses/{id}/versions/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsAddressesVersionsRetrieve(requestParameters: V1ContactsContactsAddressesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1ContactsContactsAddressesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsCompareVersionsCreateRaw(requestParameters: V1ContactsContactsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIContactRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIContactRequest',
                'Required parameter "aPIContactRequest" was null or undefined when calling v1ContactsContactsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIContactRequestToJSON(requestParameters['aPIContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsCompareVersionsCreate(requestParameters: V1ContactsContactsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContact> {
        const response = await this.v1ContactsContactsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a list of contacts to a contact group.
     */
    async v1ContactsContactsGroupsAddContactsCreateRaw(requestParameters: V1ContactsContactsGroupsAddContactsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupView>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsGroupsAddContactsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsGroupsAddContactsCreate().'
            );
        }

        if (requestParameters['aPIContactGroupViewRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIContactGroupViewRequest',
                'Required parameter "aPIContactGroupViewRequest" was null or undefined when calling v1ContactsContactsGroupsAddContactsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/groups/{id}/add_contacts/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIContactGroupViewRequestToJSON(requestParameters['aPIContactGroupViewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupViewFromJSON(jsonValue));
    }

    /**
     * Add a list of contacts to a contact group.
     */
    async v1ContactsContactsGroupsAddContactsCreate(requestParameters: V1ContactsContactsGroupsAddContactsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupView> {
        const response = await this.v1ContactsContactsGroupsAddContactsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsRevertPartialUpdateRaw(requestParameters: V1ContactsContactsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedContactRequestToJSON(requestParameters['aPIPatchedContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsRevertPartialUpdate(requestParameters: V1ContactsContactsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContact> {
        const response = await this.v1ContactsContactsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsVersionsRetrieveRaw(requestParameters: V1ContactsContactsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsVersionsRetrieve(requestParameters: V1ContactsContactsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContact> {
        const response = await this.v1ContactsContactsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsCompareVersionsCreateRaw(requestParameters: V1ContactsRichContactsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRichContact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsRichContactsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIRichContactRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIRichContactRequest',
                'Required parameter "aPIRichContactRequest" was null or undefined when calling v1ContactsRichContactsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/rich_contacts/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIRichContactRequestToJSON(requestParameters['aPIRichContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRichContactFromJSON(jsonValue));
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsCompareVersionsCreate(requestParameters: V1ContactsRichContactsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRichContact> {
        const response = await this.v1ContactsRichContactsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsCreateRaw(requestParameters: V1ContactsRichContactsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRichContact>> {
        if (requestParameters['aPIRichContactRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIRichContactRequest',
                'Required parameter "aPIRichContactRequest" was null or undefined when calling v1ContactsRichContactsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/rich_contacts/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIRichContactRequestToJSON(requestParameters['aPIRichContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRichContactFromJSON(jsonValue));
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsCreate(requestParameters: V1ContactsRichContactsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRichContact> {
        const response = await this.v1ContactsRichContactsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsDestroyRaw(requestParameters: V1ContactsRichContactsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsRichContactsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/rich_contacts/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsDestroy(requestParameters: V1ContactsRichContactsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ContactsRichContactsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsPartialUpdateRaw(requestParameters: V1ContactsRichContactsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRichContact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsRichContactsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/rich_contacts/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedRichContactRequestToJSON(requestParameters['aPIPatchedRichContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRichContactFromJSON(jsonValue));
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsPartialUpdate(requestParameters: V1ContactsRichContactsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRichContact> {
        const response = await this.v1ContactsRichContactsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsRevertPartialUpdateRaw(requestParameters: V1ContactsRichContactsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRichContact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsRichContactsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/rich_contacts/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedRichContactRequestToJSON(requestParameters['aPIPatchedRichContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRichContactFromJSON(jsonValue));
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsRevertPartialUpdate(requestParameters: V1ContactsRichContactsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRichContact> {
        const response = await this.v1ContactsRichContactsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsUpdateRaw(requestParameters: V1ContactsRichContactsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRichContact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsRichContactsUpdate().'
            );
        }

        if (requestParameters['aPIRichContactRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIRichContactRequest',
                'Required parameter "aPIRichContactRequest" was null or undefined when calling v1ContactsRichContactsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/rich_contacts/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIRichContactRequestToJSON(requestParameters['aPIRichContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRichContactFromJSON(jsonValue));
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsUpdate(requestParameters: V1ContactsRichContactsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRichContact> {
        const response = await this.v1ContactsRichContactsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsVersionsRetrieveRaw(requestParameters: V1ContactsRichContactsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRichContact>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsRichContactsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/rich_contacts/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRichContactFromJSON(jsonValue));
    }

    /**
     * List and Retrieve views that enrich contacts with context information, that is for which suppliers / customers the contact is used.
     */
    async v1ContactsRichContactsVersionsRetrieve(requestParameters: V1ContactsRichContactsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRichContact> {
        const response = await this.v1ContactsRichContactsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillFilesCompareVersionsCreateRaw(requestParameters: V1ContractBillFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBillFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractBillFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['bill'] == null) {
            throw new runtime.RequiredError(
                'bill',
                'Required parameter "bill" was null or undefined when calling v1ContractBillFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['bill'] != null) {
            formParams.append('bill', requestParameters['bill'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/contract/bill_files/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillFilesCompareVersionsCreate(requestParameters: V1ContractBillFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBillFile> {
        const response = await this.v1ContractBillFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillFilesRevertPartialUpdateRaw(requestParameters: V1ContractBillFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBillFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractBillFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['bill'] != null) {
            formParams.append('bill', requestParameters['bill'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/contract/bill_files/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillFilesRevertPartialUpdate(requestParameters: V1ContractBillFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBillFile> {
        const response = await this.v1ContractBillFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillFilesVersionsRetrieveRaw(requestParameters: V1ContractBillFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBillFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractBillFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/bill_files/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillFilesVersionsRetrieve(requestParameters: V1ContractBillFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBillFile> {
        const response = await this.v1ContractBillFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsCompareVersionsCreateRaw(requestParameters: V1ContractBillsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBill>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractBillsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIBillRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIBillRequest',
                'Required parameter "aPIBillRequest" was null or undefined when calling v1ContractBillsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/bills/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIBillRequestToJSON(requestParameters['aPIBillRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsCompareVersionsCreate(requestParameters: V1ContractBillsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBill> {
        const response = await this.v1ContractBillsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsFilesCompareVersionsCreateRaw(requestParameters: V1ContractBillsFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBillFile>> {
        if (requestParameters['billPk'] == null) {
            throw new runtime.RequiredError(
                'billPk',
                'Required parameter "billPk" was null or undefined when calling v1ContractBillsFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractBillsFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['bill'] == null) {
            throw new runtime.RequiredError(
                'bill',
                'Required parameter "bill" was null or undefined when calling v1ContractBillsFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['bill'] != null) {
            formParams.append('bill', requestParameters['bill'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/contract/bills/{bill_pk}/files/{id}/compare_versions/`.replace(`{${"bill_pk"}}`, encodeURIComponent(String(requestParameters['billPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsFilesCompareVersionsCreate(requestParameters: V1ContractBillsFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBillFile> {
        const response = await this.v1ContractBillsFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsFilesRevertPartialUpdateRaw(requestParameters: V1ContractBillsFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBillFile>> {
        if (requestParameters['billPk'] == null) {
            throw new runtime.RequiredError(
                'billPk',
                'Required parameter "billPk" was null or undefined when calling v1ContractBillsFilesRevertPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractBillsFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['bill'] != null) {
            formParams.append('bill', requestParameters['bill'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/contract/bills/{bill_pk}/files/{id}/revert/`.replace(`{${"bill_pk"}}`, encodeURIComponent(String(requestParameters['billPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsFilesRevertPartialUpdate(requestParameters: V1ContractBillsFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBillFile> {
        const response = await this.v1ContractBillsFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsFilesVersionsRetrieveRaw(requestParameters: V1ContractBillsFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBillFile>> {
        if (requestParameters['billPk'] == null) {
            throw new runtime.RequiredError(
                'billPk',
                'Required parameter "billPk" was null or undefined when calling v1ContractBillsFilesVersionsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractBillsFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/bills/{bill_pk}/files/{id}/versions/`.replace(`{${"bill_pk"}}`, encodeURIComponent(String(requestParameters['billPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsFilesVersionsRetrieve(requestParameters: V1ContractBillsFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBillFile> {
        const response = await this.v1ContractBillsFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsRevertPartialUpdateRaw(requestParameters: V1ContractBillsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBill>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractBillsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/bills/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedBillRequestToJSON(requestParameters['aPIPatchedBillRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsRevertPartialUpdate(requestParameters: V1ContractBillsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBill> {
        const response = await this.v1ContractBillsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsVersionsRetrieveRaw(requestParameters: V1ContractBillsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBill>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractBillsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/bills/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractBillsVersionsRetrieve(requestParameters: V1ContractBillsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBill> {
        const response = await this.v1ContractBillsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsCompareVersionsCreateRaw(requestParameters: V1ContractContractsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContract>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractContractsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIContractRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIContractRequest',
                'Required parameter "aPIContractRequest" was null or undefined when calling v1ContractContractsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/contracts/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIContractRequestToJSON(requestParameters['aPIContractRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsCompareVersionsCreate(requestParameters: V1ContractContractsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContract> {
        const response = await this.v1ContractContractsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsFilesCompareVersionsCreateRaw(requestParameters: V1ContractContractsFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContractFile>> {
        if (requestParameters['contractPk'] == null) {
            throw new runtime.RequiredError(
                'contractPk',
                'Required parameter "contractPk" was null or undefined when calling v1ContractContractsFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractContractsFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['contract'] == null) {
            throw new runtime.RequiredError(
                'contract',
                'Required parameter "contract" was null or undefined when calling v1ContractContractsFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['contract'] != null) {
            formParams.append('contract', requestParameters['contract'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/contract/contracts/{contract_pk}/files/{id}/compare_versions/`.replace(`{${"contract_pk"}}`, encodeURIComponent(String(requestParameters['contractPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsFilesCompareVersionsCreate(requestParameters: V1ContractContractsFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContractFile> {
        const response = await this.v1ContractContractsFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsFilesRevertPartialUpdateRaw(requestParameters: V1ContractContractsFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContractFile>> {
        if (requestParameters['contractPk'] == null) {
            throw new runtime.RequiredError(
                'contractPk',
                'Required parameter "contractPk" was null or undefined when calling v1ContractContractsFilesRevertPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractContractsFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['contract'] != null) {
            formParams.append('contract', requestParameters['contract'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/contract/contracts/{contract_pk}/files/{id}/revert/`.replace(`{${"contract_pk"}}`, encodeURIComponent(String(requestParameters['contractPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsFilesRevertPartialUpdate(requestParameters: V1ContractContractsFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContractFile> {
        const response = await this.v1ContractContractsFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsFilesVersionsRetrieveRaw(requestParameters: V1ContractContractsFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContractFile>> {
        if (requestParameters['contractPk'] == null) {
            throw new runtime.RequiredError(
                'contractPk',
                'Required parameter "contractPk" was null or undefined when calling v1ContractContractsFilesVersionsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractContractsFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/contracts/{contract_pk}/files/{id}/versions/`.replace(`{${"contract_pk"}}`, encodeURIComponent(String(requestParameters['contractPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsFilesVersionsRetrieve(requestParameters: V1ContractContractsFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContractFile> {
        const response = await this.v1ContractContractsFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsRevertPartialUpdateRaw(requestParameters: V1ContractContractsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContract>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractContractsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/contracts/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedContractRequestToJSON(requestParameters['aPIPatchedContractRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsRevertPartialUpdate(requestParameters: V1ContractContractsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContract> {
        const response = await this.v1ContractContractsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsVersionsRetrieveRaw(requestParameters: V1ContractContractsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContract>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractContractsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/contracts/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractContractsVersionsRetrieve(requestParameters: V1ContractContractsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContract> {
        const response = await this.v1ContractContractsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractFilesCompareVersionsCreateRaw(requestParameters: V1ContractFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContractFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['contract'] == null) {
            throw new runtime.RequiredError(
                'contract',
                'Required parameter "contract" was null or undefined when calling v1ContractFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['contract'] != null) {
            formParams.append('contract', requestParameters['contract'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/contract/files/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractFilesCompareVersionsCreate(requestParameters: V1ContractFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContractFile> {
        const response = await this.v1ContractFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractFilesRevertPartialUpdateRaw(requestParameters: V1ContractFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContractFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['contract'] != null) {
            formParams.append('contract', requestParameters['contract'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/contract/files/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractFilesRevertPartialUpdate(requestParameters: V1ContractFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContractFile> {
        const response = await this.v1ContractFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractFilesVersionsRetrieveRaw(requestParameters: V1ContractFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContractFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContractFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contract/files/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContractFilesVersionsRetrieve(requestParameters: V1ContractFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContractFile> {
        const response = await this.v1ContractFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1CustomerCustomersAddressesCompareVersionsCreateRaw(requestParameters: V1CustomerCustomersAddressesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['customersPk'] == null) {
            throw new runtime.RequiredError(
                'customersPk',
                'Required parameter "customersPk" was null or undefined when calling v1CustomerCustomersAddressesCompareVersionsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1CustomerCustomersAddressesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIAddressRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAddressRequest',
                'Required parameter "aPIAddressRequest" was null or undefined when calling v1CustomerCustomersAddressesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/customer/customers/{customers_pk}/addresses/{id}/compare_versions/`.replace(`{${"customers_pk"}}`, encodeURIComponent(String(requestParameters['customersPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAddressRequestToJSON(requestParameters['aPIAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1CustomerCustomersAddressesCompareVersionsCreate(requestParameters: V1CustomerCustomersAddressesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1CustomerCustomersAddressesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1CustomerCustomersAddressesRevertPartialUpdateRaw(requestParameters: V1CustomerCustomersAddressesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['customersPk'] == null) {
            throw new runtime.RequiredError(
                'customersPk',
                'Required parameter "customersPk" was null or undefined when calling v1CustomerCustomersAddressesRevertPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1CustomerCustomersAddressesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/customer/customers/{customers_pk}/addresses/{id}/revert/`.replace(`{${"customers_pk"}}`, encodeURIComponent(String(requestParameters['customersPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedAddressRequestToJSON(requestParameters['aPIPatchedAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1CustomerCustomersAddressesRevertPartialUpdate(requestParameters: V1CustomerCustomersAddressesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1CustomerCustomersAddressesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1CustomerCustomersAddressesVersionsRetrieveRaw(requestParameters: V1CustomerCustomersAddressesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['customersPk'] == null) {
            throw new runtime.RequiredError(
                'customersPk',
                'Required parameter "customersPk" was null or undefined when calling v1CustomerCustomersAddressesVersionsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1CustomerCustomersAddressesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/customer/customers/{customers_pk}/addresses/{id}/versions/`.replace(`{${"customers_pk"}}`, encodeURIComponent(String(requestParameters['customersPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1CustomerCustomersAddressesVersionsRetrieve(requestParameters: V1CustomerCustomersAddressesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1CustomerCustomersAddressesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * E2E Test Setup/Cleanup API endpoint.  Creates or destroys isolated test organizations for E2E testing. Secured with API Key authentication.  Request body:     {         \"action\": \"setup\" | \"cleanup\",         \"run_id\": \"unique-identifier\",         \"language\": \"en\" | \"de\"  (optional, default: \"en\", only for setup)     }  Response (setup):     {         \"email\": \"e2e-xxx@test.assemblean.com\",         \"password\": \"...\",         \"run_id\": \"...\",         \"org_name\": \"E2E-xxx\"     }  Response (cleanup):     {         \"status\": \"cleaned\" | \"not_found\",         \"run_id\": \"...\"     }
     */
    async v1E2eTestCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/e2e-test/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * E2E Test Setup/Cleanup API endpoint.  Creates or destroys isolated test organizations for E2E testing. Secured with API Key authentication.  Request body:     {         \"action\": \"setup\" | \"cleanup\",         \"run_id\": \"unique-identifier\",         \"language\": \"en\" | \"de\"  (optional, default: \"en\", only for setup)     }  Response (setup):     {         \"email\": \"e2e-xxx@test.assemblean.com\",         \"password\": \"...\",         \"run_id\": \"...\",         \"org_name\": \"E2E-xxx\"     }  Response (cleanup):     {         \"status\": \"cleaned\" | \"not_found\",         \"run_id\": \"...\"     }
     */
    async v1E2eTestCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1E2eTestCreateRaw(initOverrides);
    }

    /**
     */
    async v1GeneralFilesDestroyRaw(requestParameters: V1GeneralFilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fileName'] == null) {
            throw new runtime.RequiredError(
                'fileName',
                'Required parameter "fileName" was null or undefined when calling v1GeneralFilesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/general/files/{file_name}`.replace(`{${"file_name"}}`, encodeURIComponent(String(requestParameters['fileName']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async v1GeneralFilesDestroy(requestParameters: V1GeneralFilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1GeneralFilesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Return all articles that can safely be inserted as a bom child of the current article (pk) without producing circular bom relationships.
     */
    async v1ItemsArticlesAllowedBomChildrenRetrieveRaw(requestParameters: V1ItemsArticlesAllowedBomChildrenRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesAllowedBomChildrenRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/allowed_bom_children/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Return all articles that can safely be inserted as a bom child of the current article (pk) without producing circular bom relationships.
     */
    async v1ItemsArticlesAllowedBomChildrenRetrieve(requestParameters: V1ItemsArticlesAllowedBomChildrenRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesAllowedBomChildrenRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return all articles that are ancestors to the specified article.
     */
    async v1ItemsArticlesAncestorsRetrieveRaw(requestParameters: V1ItemsArticlesAncestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesAncestorsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/ancestors/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Return all articles that are ancestors to the specified article.
     */
    async v1ItemsArticlesAncestorsRetrieve(requestParameters: V1ItemsArticlesAncestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesAncestorsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomCompareVersionsCreateRaw(requestParameters: V1ItemsArticlesBomCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomCompareVersionsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesBomCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIBOMRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIBOMRequest',
                'Required parameter "aPIBOMRequest" was null or undefined when calling v1ItemsArticlesBomCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/{id}/compare_versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIBOMRequestToJSON(requestParameters['aPIBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomCompareVersionsCreate(requestParameters: V1ItemsArticlesBomCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsArticlesBomCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomRevertPartialUpdateRaw(requestParameters: V1ItemsArticlesBomRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomRevertPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesBomRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/{id}/revert/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedBOMRequestToJSON(requestParameters['aPIPatchedBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomRevertPartialUpdate(requestParameters: V1ItemsArticlesBomRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsArticlesBomRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomVersionsRetrieveRaw(requestParameters: V1ItemsArticlesBomVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomVersionsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesBomVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/{id}/versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomVersionsRetrieve(requestParameters: V1ItemsArticlesBomVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsArticlesBomVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesCategoriesCompareVersionsCreateRaw(requestParameters: V1ItemsArticlesCategoriesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APICategory>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesCategoriesCompareVersionsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesCategoriesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPICategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'aPICategoryRequest',
                'Required parameter "aPICategoryRequest" was null or undefined when calling v1ItemsArticlesCategoriesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/categories/{id}/compare_versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APICategoryRequestToJSON(requestParameters['aPICategoryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APICategoryFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesCategoriesCompareVersionsCreate(requestParameters: V1ItemsArticlesCategoriesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APICategory> {
        const response = await this.v1ItemsArticlesCategoriesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesCategoriesRevertPartialUpdateRaw(requestParameters: V1ItemsArticlesCategoriesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APICategory>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesCategoriesRevertPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesCategoriesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/categories/{id}/revert/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedCategoryRequestToJSON(requestParameters['aPIPatchedCategoryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APICategoryFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesCategoriesRevertPartialUpdate(requestParameters: V1ItemsArticlesCategoriesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APICategory> {
        const response = await this.v1ItemsArticlesCategoriesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesCategoriesVersionsRetrieveRaw(requestParameters: V1ItemsArticlesCategoriesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APICategory>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesCategoriesVersionsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesCategoriesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/categories/{id}/versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APICategoryFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesCategoriesVersionsRetrieve(requestParameters: V1ItemsArticlesCategoriesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APICategory> {
        const response = await this.v1ItemsArticlesCategoriesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesCompareVersionsCreateRaw(requestParameters: V1ItemsArticlesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIArticleRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIArticleRequest',
                'Required parameter "aPIArticleRequest" was null or undefined when calling v1ItemsArticlesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIArticleRequestToJSON(requestParameters['aPIArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesCompareVersionsCreate(requestParameters: V1ItemsArticlesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesFilesCompareVersionsCreateRaw(requestParameters: V1ItemsArticlesFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleFile>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['article'] == null) {
            throw new runtime.RequiredError(
                'article',
                'Required parameter "article" was null or undefined when calling v1ItemsArticlesFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['article'] != null) {
            formParams.append('article', requestParameters['article'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/files/{id}/compare_versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesFilesCompareVersionsCreate(requestParameters: V1ItemsArticlesFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleFile> {
        const response = await this.v1ItemsArticlesFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trigger Hoops converter for a single ArticleFile to generate a .scs file.
     */
    async v1ItemsArticlesFilesConvertScsCreateRaw(requestParameters: V1ItemsArticlesFilesConvertScsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleFile>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesFilesConvertScsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesFilesConvertScsCreate().'
            );
        }

        if (requestParameters['article'] == null) {
            throw new runtime.RequiredError(
                'article',
                'Required parameter "article" was null or undefined when calling v1ItemsArticlesFilesConvertScsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['article'] != null) {
            formParams.append('article', requestParameters['article'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/files/{id}/convert_scs/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFileFromJSON(jsonValue));
    }

    /**
     * Trigger Hoops converter for a single ArticleFile to generate a .scs file.
     */
    async v1ItemsArticlesFilesConvertScsCreate(requestParameters: V1ItemsArticlesFilesConvertScsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleFile> {
        const response = await this.v1ItemsArticlesFilesConvertScsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesFilesRevertPartialUpdateRaw(requestParameters: V1ItemsArticlesFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleFile>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesFilesRevertPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['article'] != null) {
            formParams.append('article', requestParameters['article'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/files/{id}/revert/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesFilesRevertPartialUpdate(requestParameters: V1ItemsArticlesFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleFile> {
        const response = await this.v1ItemsArticlesFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesFilesVersionsRetrieveRaw(requestParameters: V1ItemsArticlesFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleFile>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesFilesVersionsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/files/{id}/versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesFilesVersionsRetrieve(requestParameters: V1ItemsArticlesFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleFile> {
        const response = await this.v1ItemsArticlesFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesPropertiesCompareVersionsCreateRaw(requestParameters: V1ItemsArticlesPropertiesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIProperty>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesPropertiesCompareVersionsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesPropertiesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIPropertyRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIPropertyRequest',
                'Required parameter "aPIPropertyRequest" was null or undefined when calling v1ItemsArticlesPropertiesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/properties/{id}/compare_versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIPropertyRequestToJSON(requestParameters['aPIPropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPropertyFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesPropertiesCompareVersionsCreate(requestParameters: V1ItemsArticlesPropertiesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIProperty> {
        const response = await this.v1ItemsArticlesPropertiesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesPropertiesRevertPartialUpdateRaw(requestParameters: V1ItemsArticlesPropertiesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIProperty>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesPropertiesRevertPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesPropertiesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/properties/{id}/revert/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedPropertyRequestToJSON(requestParameters['aPIPatchedPropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPropertyFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesPropertiesRevertPartialUpdate(requestParameters: V1ItemsArticlesPropertiesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIProperty> {
        const response = await this.v1ItemsArticlesPropertiesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesPropertiesVersionsRetrieveRaw(requestParameters: V1ItemsArticlesPropertiesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIProperty>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesPropertiesVersionsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesPropertiesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/properties/{id}/versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPropertyFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesPropertiesVersionsRetrieve(requestParameters: V1ItemsArticlesPropertiesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIProperty> {
        const response = await this.v1ItemsArticlesPropertiesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesRequestsCompareVersionsCreateRaw(requestParameters: V1ItemsArticlesRequestsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesRequestsCompareVersionsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesRequestsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIRequestRequest',
                'Required parameter "aPIRequestRequest" was null or undefined when calling v1ItemsArticlesRequestsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/requests/{id}/compare_versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIRequestRequestToJSON(requestParameters['aPIRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesRequestsCompareVersionsCreate(requestParameters: V1ItemsArticlesRequestsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1ItemsArticlesRequestsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Completes a temporary Request. This action is required to change the Request state from temporary to persistent. Staff members are only allowed to act on persistent Requests.  Note:     This view *requires* the Request access_secret to be send with the     X-ACCESS-SECRET header in the PATCH-request in order to accept the     request. If the access_secret is not provided or does not match the     access_secret field, the request is rejected.      Also this view/action is only accepted once per temporary Request     (as it will no longer be a temporary, but a persistent Request     after completing the action).
     */
    async v1ItemsArticlesRequestsCompletePartialUpdateRaw(requestParameters: V1ItemsArticlesRequestsCompletePartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesRequestsCompletePartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesRequestsCompletePartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/requests/{id}/complete/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedRequestRequestToJSON(requestParameters['aPIPatchedRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Completes a temporary Request. This action is required to change the Request state from temporary to persistent. Staff members are only allowed to act on persistent Requests.  Note:     This view *requires* the Request access_secret to be send with the     X-ACCESS-SECRET header in the PATCH-request in order to accept the     request. If the access_secret is not provided or does not match the     access_secret field, the request is rejected.      Also this view/action is only accepted once per temporary Request     (as it will no longer be a temporary, but a persistent Request     after completing the action).
     */
    async v1ItemsArticlesRequestsCompletePartialUpdate(requestParameters: V1ItemsArticlesRequestsCompletePartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1ItemsArticlesRequestsCompletePartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Publish processing progress updates for temporary Requests (AQG workflow).
     */
    async v1ItemsArticlesRequestsProcessingStatusCreateRaw(requestParameters: V1ItemsArticlesRequestsProcessingStatusCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesRequestsProcessingStatusCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesRequestsProcessingStatusCreate().'
            );
        }

        if (requestParameters['aPIRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIRequestRequest',
                'Required parameter "aPIRequestRequest" was null or undefined when calling v1ItemsArticlesRequestsProcessingStatusCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/requests/{id}/processing-status/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIRequestRequestToJSON(requestParameters['aPIRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Publish processing progress updates for temporary Requests (AQG workflow).
     */
    async v1ItemsArticlesRequestsProcessingStatusCreate(requestParameters: V1ItemsArticlesRequestsProcessingStatusCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1ItemsArticlesRequestsProcessingStatusCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesRequestsRevertPartialUpdateRaw(requestParameters: V1ItemsArticlesRequestsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesRequestsRevertPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesRequestsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/requests/{id}/revert/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedRequestRequestToJSON(requestParameters['aPIPatchedRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesRequestsRevertPartialUpdate(requestParameters: V1ItemsArticlesRequestsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1ItemsArticlesRequestsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesRequestsVersionsRetrieveRaw(requestParameters: V1ItemsArticlesRequestsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesRequestsVersionsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesRequestsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/requests/{id}/versions/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesRequestsVersionsRetrieve(requestParameters: V1ItemsArticlesRequestsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1ItemsArticlesRequestsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesRevertPartialUpdateRaw(requestParameters: V1ItemsArticlesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedArticleRequestToJSON(requestParameters['aPIPatchedArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesRevertPartialUpdate(requestParameters: V1ItemsArticlesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesVersionsRetrieveRaw(requestParameters: V1ItemsArticlesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * DEPRECATED! Use the serializer mixin below instead.  We replaced this class with the FieldLevelPermissionMixin for serializers as this mixin required a view to be instantiated to work. Therefore the fields of a serializer could not be filtered when the view was not used, for example when using expandable fields of the SerializerExtensionsMixin.  The new mixin works on the serializer-level and therefore allows to apply field level permissions every time the serializer is instantiated, detached from any view.    Mixin to provide model-field level permissions. For this to work the serializer you use must inherit the \'SerializerExtensionsMixin\'!  How to use:     1. Add the mixin as the first inherited class to your viewset     2. Add the \'model_class\' class attribute and set it to the model class        that your viewset is concerned with.        If your viewset is concerned with multiple models you can define        a \'get_model_class\' method to return the right model in each situation.     3. Define a \'get_forbidden_fields\' classmethod on the according model        classes that returns a list of fieldnames for all fields that a user        is not allowed to view/edit. Example:              @classmethod             def get_forbidden_fields(cls, action: Literal[\"view\", \"create\", \"edit\"],                                      user) -> List[str]:                 if action == \"view\":                     if user.is_staff: return []                      # for all other users                     return [                         \"forbidden_field_name_1\",                         \"forbidden_field_name_2,                     ]                 return []
     */
    async v1ItemsArticlesVersionsRetrieve(requestParameters: V1ItemsArticlesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsArticlesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBarcodeTypesCompareVersionsCreateRaw(requestParameters: V1ItemsBarcodeTypesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBarcodeType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBarcodeTypesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIBarcodeTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIBarcodeTypeRequest',
                'Required parameter "aPIBarcodeTypeRequest" was null or undefined when calling v1ItemsBarcodeTypesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/barcode_types/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIBarcodeTypeRequestToJSON(requestParameters['aPIBarcodeTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBarcodeTypeFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBarcodeTypesCompareVersionsCreate(requestParameters: V1ItemsBarcodeTypesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBarcodeType> {
        const response = await this.v1ItemsBarcodeTypesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBarcodeTypesRevertPartialUpdateRaw(requestParameters: V1ItemsBarcodeTypesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBarcodeType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBarcodeTypesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/barcode_types/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedBarcodeTypeRequestToJSON(requestParameters['aPIPatchedBarcodeTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBarcodeTypeFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBarcodeTypesRevertPartialUpdate(requestParameters: V1ItemsBarcodeTypesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBarcodeType> {
        const response = await this.v1ItemsBarcodeTypesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBarcodeTypesVersionsRetrieveRaw(requestParameters: V1ItemsBarcodeTypesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBarcodeType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBarcodeTypesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/barcode_types/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBarcodeTypeFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBarcodeTypesVersionsRetrieve(requestParameters: V1ItemsBarcodeTypesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBarcodeType> {
        const response = await this.v1ItemsBarcodeTypesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomBasesCompareVersionsCreateRaw(requestParameters: V1ItemsBomBasesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomBasesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIArticleRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIArticleRequest',
                'Required parameter "aPIArticleRequest" was null or undefined when calling v1ItemsBomBasesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/bom_bases/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIArticleRequestToJSON(requestParameters['aPIArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomBasesCompareVersionsCreate(requestParameters: V1ItemsBomBasesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsBomBasesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomBasesRevertPartialUpdateRaw(requestParameters: V1ItemsBomBasesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomBasesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/bom_bases/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedArticleRequestToJSON(requestParameters['aPIPatchedArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomBasesRevertPartialUpdate(requestParameters: V1ItemsBomBasesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsBomBasesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomBasesVersionsRetrieveRaw(requestParameters: V1ItemsBomBasesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomBasesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/bom_bases/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomBasesVersionsRetrieve(requestParameters: V1ItemsBomBasesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1ItemsBomBasesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsCompareVersionsCreateRaw(requestParameters: V1ItemsBomsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIBOMRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIBOMRequest',
                'Required parameter "aPIBOMRequest" was null or undefined when calling v1ItemsBomsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIBOMRequestToJSON(requestParameters['aPIBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsCompareVersionsCreate(requestParameters: V1ItemsBomsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsBomsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsRevertPartialUpdateRaw(requestParameters: V1ItemsBomsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedBOMRequestToJSON(requestParameters['aPIPatchedBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsRevertPartialUpdate(requestParameters: V1ItemsBomsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsBomsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsVersionsRetrieveRaw(requestParameters: V1ItemsBomsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsVersionsRetrieve(requestParameters: V1ItemsBomsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsBomsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBrandsCompareVersionsCreateRaw(requestParameters: V1ItemsBrandsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBrand>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBrandsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIBrandRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIBrandRequest',
                'Required parameter "aPIBrandRequest" was null or undefined when calling v1ItemsBrandsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/brands/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIBrandRequestToJSON(requestParameters['aPIBrandRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBrandFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBrandsCompareVersionsCreate(requestParameters: V1ItemsBrandsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBrand> {
        const response = await this.v1ItemsBrandsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBrandsRevertPartialUpdateRaw(requestParameters: V1ItemsBrandsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBrand>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBrandsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/brands/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedBrandRequestToJSON(requestParameters['aPIPatchedBrandRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBrandFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBrandsRevertPartialUpdate(requestParameters: V1ItemsBrandsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBrand> {
        const response = await this.v1ItemsBrandsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBrandsVersionsRetrieveRaw(requestParameters: V1ItemsBrandsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBrand>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBrandsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/brands/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBrandFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBrandsVersionsRetrieve(requestParameters: V1ItemsBrandsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBrand> {
        const response = await this.v1ItemsBrandsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsCategoriesCompareVersionsCreateRaw(requestParameters: V1ItemsCategoriesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APICategory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsCategoriesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPICategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'aPICategoryRequest',
                'Required parameter "aPICategoryRequest" was null or undefined when calling v1ItemsCategoriesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/categories/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APICategoryRequestToJSON(requestParameters['aPICategoryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APICategoryFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsCategoriesCompareVersionsCreate(requestParameters: V1ItemsCategoriesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APICategory> {
        const response = await this.v1ItemsCategoriesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsCategoriesRevertPartialUpdateRaw(requestParameters: V1ItemsCategoriesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APICategory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsCategoriesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/categories/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedCategoryRequestToJSON(requestParameters['aPIPatchedCategoryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APICategoryFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsCategoriesRevertPartialUpdate(requestParameters: V1ItemsCategoriesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APICategory> {
        const response = await this.v1ItemsCategoriesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsCategoriesVersionsRetrieveRaw(requestParameters: V1ItemsCategoriesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APICategory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsCategoriesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/categories/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APICategoryFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsCategoriesVersionsRetrieve(requestParameters: V1ItemsCategoriesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APICategory> {
        const response = await this.v1ItemsCategoriesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFamiliesCompareVersionsCreateRaw(requestParameters: V1ItemsFamiliesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIFamily>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsFamiliesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIFamilyRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIFamilyRequest',
                'Required parameter "aPIFamilyRequest" was null or undefined when calling v1ItemsFamiliesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/families/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIFamilyRequestToJSON(requestParameters['aPIFamilyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIFamilyFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFamiliesCompareVersionsCreate(requestParameters: V1ItemsFamiliesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIFamily> {
        const response = await this.v1ItemsFamiliesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFamiliesRevertPartialUpdateRaw(requestParameters: V1ItemsFamiliesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIFamily>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsFamiliesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/families/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedFamilyRequestToJSON(requestParameters['aPIPatchedFamilyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIFamilyFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFamiliesRevertPartialUpdate(requestParameters: V1ItemsFamiliesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIFamily> {
        const response = await this.v1ItemsFamiliesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFamiliesVersionsRetrieveRaw(requestParameters: V1ItemsFamiliesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIFamily>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsFamiliesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/families/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIFamilyFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFamiliesVersionsRetrieve(requestParameters: V1ItemsFamiliesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIFamily> {
        const response = await this.v1ItemsFamiliesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFilesCompareVersionsCreateRaw(requestParameters: V1ItemsFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['article'] == null) {
            throw new runtime.RequiredError(
                'article',
                'Required parameter "article" was null or undefined when calling v1ItemsFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['article'] != null) {
            formParams.append('article', requestParameters['article'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/items/files/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFilesCompareVersionsCreate(requestParameters: V1ItemsFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleFile> {
        const response = await this.v1ItemsFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trigger Hoops converter for a single ArticleFile to generate a .scs file.
     */
    async v1ItemsFilesConvertScsCreateRaw(requestParameters: V1ItemsFilesConvertScsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsFilesConvertScsCreate().'
            );
        }

        if (requestParameters['article'] == null) {
            throw new runtime.RequiredError(
                'article',
                'Required parameter "article" was null or undefined when calling v1ItemsFilesConvertScsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['article'] != null) {
            formParams.append('article', requestParameters['article'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/items/files/{id}/convert_scs/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFileFromJSON(jsonValue));
    }

    /**
     * Trigger Hoops converter for a single ArticleFile to generate a .scs file.
     */
    async v1ItemsFilesConvertScsCreate(requestParameters: V1ItemsFilesConvertScsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleFile> {
        const response = await this.v1ItemsFilesConvertScsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFilesRevertPartialUpdateRaw(requestParameters: V1ItemsFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['article'] != null) {
            formParams.append('article', requestParameters['article'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/items/files/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFilesRevertPartialUpdate(requestParameters: V1ItemsFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleFile> {
        const response = await this.v1ItemsFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFilesVersionsRetrieveRaw(requestParameters: V1ItemsFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/files/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsFilesVersionsRetrieve(requestParameters: V1ItemsFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleFile> {
        const response = await this.v1ItemsFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsCompareVersionsCreateRaw(requestParameters: V1ItemsMaterialsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMaterial>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsMaterialsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIMaterialRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIMaterialRequest',
                'Required parameter "aPIMaterialRequest" was null or undefined when calling v1ItemsMaterialsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/materials/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIMaterialRequestToJSON(requestParameters['aPIMaterialRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMaterialFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsCompareVersionsCreate(requestParameters: V1ItemsMaterialsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMaterial> {
        const response = await this.v1ItemsMaterialsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsRevertPartialUpdateRaw(requestParameters: V1ItemsMaterialsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMaterial>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsMaterialsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/materials/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedMaterialRequestToJSON(requestParameters['aPIPatchedMaterialRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMaterialFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsRevertPartialUpdate(requestParameters: V1ItemsMaterialsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMaterial> {
        const response = await this.v1ItemsMaterialsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsVersionsRetrieveRaw(requestParameters: V1ItemsMaterialsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMaterial>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsMaterialsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/materials/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMaterialFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsVersionsRetrieve(requestParameters: V1ItemsMaterialsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMaterial> {
        const response = await this.v1ItemsMaterialsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsPropertiesCompareVersionsCreateRaw(requestParameters: V1ItemsPropertiesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIProperty>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsPropertiesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIPropertyRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIPropertyRequest',
                'Required parameter "aPIPropertyRequest" was null or undefined when calling v1ItemsPropertiesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/properties/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIPropertyRequestToJSON(requestParameters['aPIPropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPropertyFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsPropertiesCompareVersionsCreate(requestParameters: V1ItemsPropertiesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIProperty> {
        const response = await this.v1ItemsPropertiesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsPropertiesRevertPartialUpdateRaw(requestParameters: V1ItemsPropertiesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIProperty>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsPropertiesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/properties/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedPropertyRequestToJSON(requestParameters['aPIPatchedPropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPropertyFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsPropertiesRevertPartialUpdate(requestParameters: V1ItemsPropertiesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIProperty> {
        const response = await this.v1ItemsPropertiesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsPropertiesVersionsRetrieveRaw(requestParameters: V1ItemsPropertiesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIProperty>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsPropertiesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/properties/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPropertyFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsPropertiesVersionsRetrieve(requestParameters: V1ItemsPropertiesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIProperty> {
        const response = await this.v1ItemsPropertiesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * View that returns all sharepoints that are used to share unrelated articles.
     */
    async v1ItemsSharepointsArticleSharesRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APISharepoint>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/sharepoints/article_shares/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APISharepointFromJSON(jsonValue));
    }

    /**
     * View that returns all sharepoints that are used to share unrelated articles.
     */
    async v1ItemsSharepointsArticleSharesRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APISharepoint> {
        const response = await this.v1ItemsSharepointsArticleSharesRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * ViewSet required to enable the Sharepoint feature. A Sharepoint is intended to enable users to share articles with people outside of their organization/root_account. This is possible by creating guest users with very limited access permissions within their organization, that can be used by others to view specified data within that organization.  A sharepoint can be configured to share single articles, multiple articles, and BOMs containing multiple articles. Further it is possible to share guest requests by creating an article representation of that request (that article and guest request should then be linked via the ForeignKey relationship on the article).
     */
    async v1ItemsSharepointsAutomaticSharesRetrieveRaw(requestParameters: V1ItemsSharepointsAutomaticSharesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIGuestUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsSharepointsAutomaticSharesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/sharepoints/{id}/automatic_shares/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIGuestUserFromJSON(jsonValue));
    }

    /**
     * ViewSet required to enable the Sharepoint feature. A Sharepoint is intended to enable users to share articles with people outside of their organization/root_account. This is possible by creating guest users with very limited access permissions within their organization, that can be used by others to view specified data within that organization.  A sharepoint can be configured to share single articles, multiple articles, and BOMs containing multiple articles. Further it is possible to share guest requests by creating an article representation of that request (that article and guest request should then be linked via the ForeignKey relationship on the article).
     */
    async v1ItemsSharepointsAutomaticSharesRetrieve(requestParameters: V1ItemsSharepointsAutomaticSharesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIGuestUser> {
        const response = await this.v1ItemsSharepointsAutomaticSharesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * View that returns all sharepoints that are used to share BOMs.
     */
    async v1ItemsSharepointsBomSharesRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APISharepoint>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/sharepoints/bom_shares/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APISharepointFromJSON(jsonValue));
    }

    /**
     * View that returns all sharepoints that are used to share BOMs.
     */
    async v1ItemsSharepointsBomSharesRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APISharepoint> {
        const response = await this.v1ItemsSharepointsBomSharesRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * View that returns all sharepoints that are used to share guest requests (through guest-request-articles).
     */
    async v1ItemsSharepointsGuestRequestSharesRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APISharepoint>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/sharepoints/guest_request_shares/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APISharepointFromJSON(jsonValue));
    }

    /**
     * View that returns all sharepoints that are used to share guest requests (through guest-request-articles).
     */
    async v1ItemsSharepointsGuestRequestSharesRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APISharepoint> {
        const response = await this.v1ItemsSharepointsGuestRequestSharesRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * ViewSet required to enable the Sharepoint feature. A Sharepoint is intended to enable users to share articles with people outside of their organization/root_account. This is possible by creating guest users with very limited access permissions within their organization, that can be used by others to view specified data within that organization.  A sharepoint can be configured to share single articles, multiple articles, and BOMs containing multiple articles. Further it is possible to share guest requests by creating an article representation of that request (that article and guest request should then be linked via the ForeignKey relationship on the article).
     */
    async v1ItemsSharepointsManualSharesRetrieveRaw(requestParameters: V1ItemsSharepointsManualSharesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIGuestUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsSharepointsManualSharesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/sharepoints/{id}/manual_shares/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIGuestUserFromJSON(jsonValue));
    }

    /**
     * ViewSet required to enable the Sharepoint feature. A Sharepoint is intended to enable users to share articles with people outside of their organization/root_account. This is possible by creating guest users with very limited access permissions within their organization, that can be used by others to view specified data within that organization.  A sharepoint can be configured to share single articles, multiple articles, and BOMs containing multiple articles. Further it is possible to share guest requests by creating an article representation of that request (that article and guest request should then be linked via the ForeignKey relationship on the article).
     */
    async v1ItemsSharepointsManualSharesRetrieve(requestParameters: V1ItemsSharepointsManualSharesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIGuestUser> {
        const response = await this.v1ItemsSharepointsManualSharesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * View that returns all sharepoints that are used to share a request (through \'shadow articles\' of requested articles).
     */
    async v1ItemsSharepointsRequestSharesRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APISharepoint>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/sharepoints/request_shares/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APISharepointFromJSON(jsonValue));
    }

    /**
     * View that returns all sharepoints that are used to share a request (through \'shadow articles\' of requested articles).
     */
    async v1ItemsSharepointsRequestSharesRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APISharepoint> {
        const response = await this.v1ItemsSharepointsRequestSharesRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsTypesCompareVersionsCreateRaw(requestParameters: V1ItemsTypesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsTypesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPITypeRequest'] == null) {
            throw new runtime.RequiredError(
                'aPITypeRequest',
                'Required parameter "aPITypeRequest" was null or undefined when calling v1ItemsTypesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/types/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APITypeRequestToJSON(requestParameters['aPITypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APITypeFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsTypesCompareVersionsCreate(requestParameters: V1ItemsTypesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIType> {
        const response = await this.v1ItemsTypesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsTypesRevertPartialUpdateRaw(requestParameters: V1ItemsTypesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsTypesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/types/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedTypeRequestToJSON(requestParameters['aPIPatchedTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APITypeFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsTypesRevertPartialUpdate(requestParameters: V1ItemsTypesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIType> {
        const response = await this.v1ItemsTypesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsTypesVersionsRetrieveRaw(requestParameters: V1ItemsTypesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsTypesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/types/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APITypeFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsTypesVersionsRetrieve(requestParameters: V1ItemsTypesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIType> {
        const response = await this.v1ItemsTypesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsWasteCompareVersionsCreateRaw(requestParameters: V1ItemsWasteCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIWaste>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsWasteCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIWasteRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIWasteRequest',
                'Required parameter "aPIWasteRequest" was null or undefined when calling v1ItemsWasteCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/waste/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIWasteRequestToJSON(requestParameters['aPIWasteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIWasteFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsWasteCompareVersionsCreate(requestParameters: V1ItemsWasteCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIWaste> {
        const response = await this.v1ItemsWasteCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsWasteRevertPartialUpdateRaw(requestParameters: V1ItemsWasteRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIWaste>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsWasteRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/waste/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedWasteRequestToJSON(requestParameters['aPIPatchedWasteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIWasteFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsWasteRevertPartialUpdate(requestParameters: V1ItemsWasteRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIWaste> {
        const response = await this.v1ItemsWasteRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsWasteVersionsRetrieveRaw(requestParameters: V1ItemsWasteVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIWaste>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsWasteVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/waste/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIWasteFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsWasteVersionsRetrieve(requestParameters: V1ItemsWasteVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIWaste> {
        const response = await this.v1ItemsWasteVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsInventoryMovementsCompareVersionsCreateRaw(requestParameters: V1LogisticsInventoryMovementsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIInventoryMovement>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsInventoryMovementsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIInventoryMovementRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIInventoryMovementRequest',
                'Required parameter "aPIInventoryMovementRequest" was null or undefined when calling v1LogisticsInventoryMovementsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/inventory_movements/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIInventoryMovementRequestToJSON(requestParameters['aPIInventoryMovementRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIInventoryMovementFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsInventoryMovementsCompareVersionsCreate(requestParameters: V1LogisticsInventoryMovementsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIInventoryMovement> {
        const response = await this.v1LogisticsInventoryMovementsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsInventoryMovementsRevertPartialUpdateRaw(requestParameters: V1LogisticsInventoryMovementsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIInventoryMovement>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsInventoryMovementsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/inventory_movements/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedInventoryMovementRequestToJSON(requestParameters['aPIPatchedInventoryMovementRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIInventoryMovementFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsInventoryMovementsRevertPartialUpdate(requestParameters: V1LogisticsInventoryMovementsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIInventoryMovement> {
        const response = await this.v1LogisticsInventoryMovementsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsInventoryMovementsVersionsRetrieveRaw(requestParameters: V1LogisticsInventoryMovementsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIInventoryMovement>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsInventoryMovementsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/inventory_movements/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIInventoryMovementFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsInventoryMovementsVersionsRetrieve(requestParameters: V1LogisticsInventoryMovementsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIInventoryMovement> {
        const response = await this.v1LogisticsInventoryMovementsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesCompareVersionsCreateRaw(requestParameters: V1LogisticsStorageArticlesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStorageArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsStorageArticlesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIStorageArticleRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIStorageArticleRequest',
                'Required parameter "aPIStorageArticleRequest" was null or undefined when calling v1LogisticsStorageArticlesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/storage_articles/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIStorageArticleRequestToJSON(requestParameters['aPIStorageArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStorageArticleFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesCompareVersionsCreate(requestParameters: V1LogisticsStorageArticlesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStorageArticle> {
        const response = await this.v1LogisticsStorageArticlesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesRelocateCreateRaw(requestParameters: V1LogisticsStorageArticlesRelocateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStorageArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsStorageArticlesRelocateCreate().'
            );
        }

        if (requestParameters['aPIStorageArticleRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIStorageArticleRequest',
                'Required parameter "aPIStorageArticleRequest" was null or undefined when calling v1LogisticsStorageArticlesRelocateCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/storage_articles/{id}/relocate/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIStorageArticleRequestToJSON(requestParameters['aPIStorageArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStorageArticleFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesRelocateCreate(requestParameters: V1LogisticsStorageArticlesRelocateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStorageArticle> {
        const response = await this.v1LogisticsStorageArticlesRelocateCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesRevertPartialUpdateRaw(requestParameters: V1LogisticsStorageArticlesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStorageArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsStorageArticlesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/storage_articles/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedStorageArticleRequestToJSON(requestParameters['aPIPatchedStorageArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStorageArticleFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesRevertPartialUpdate(requestParameters: V1LogisticsStorageArticlesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStorageArticle> {
        const response = await this.v1LogisticsStorageArticlesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesStoreCreateRaw(requestParameters: V1LogisticsStorageArticlesStoreCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStorageArticle>> {
        if (requestParameters['aPIStorageArticleRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIStorageArticleRequest',
                'Required parameter "aPIStorageArticleRequest" was null or undefined when calling v1LogisticsStorageArticlesStoreCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/storage_articles/store/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIStorageArticleRequestToJSON(requestParameters['aPIStorageArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStorageArticleFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesStoreCreate(requestParameters: V1LogisticsStorageArticlesStoreCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStorageArticle> {
        const response = await this.v1LogisticsStorageArticlesStoreCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesVersionsRetrieveRaw(requestParameters: V1LogisticsStorageArticlesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStorageArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsStorageArticlesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/storage_articles/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStorageArticleFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesVersionsRetrieve(requestParameters: V1LogisticsStorageArticlesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStorageArticle> {
        const response = await this.v1LogisticsStorageArticlesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesWithdrawCreateRaw(requestParameters: V1LogisticsStorageArticlesWithdrawCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStorageArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsStorageArticlesWithdrawCreate().'
            );
        }

        if (requestParameters['aPIStorageArticleRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIStorageArticleRequest',
                'Required parameter "aPIStorageArticleRequest" was null or undefined when calling v1LogisticsStorageArticlesWithdrawCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/storage_articles/{id}/withdraw/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIStorageArticleRequestToJSON(requestParameters['aPIStorageArticleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStorageArticleFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStorageArticlesWithdrawCreate(requestParameters: V1LogisticsStorageArticlesWithdrawCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStorageArticle> {
        const response = await this.v1LogisticsStorageArticlesWithdrawCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStoragePositionsCompareVersionsCreateRaw(requestParameters: V1LogisticsStoragePositionsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStoragePosition>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsStoragePositionsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIStoragePositionRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIStoragePositionRequest',
                'Required parameter "aPIStoragePositionRequest" was null or undefined when calling v1LogisticsStoragePositionsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/storage_positions/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIStoragePositionRequestToJSON(requestParameters['aPIStoragePositionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStoragePositionFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStoragePositionsCompareVersionsCreate(requestParameters: V1LogisticsStoragePositionsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStoragePosition> {
        const response = await this.v1LogisticsStoragePositionsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStoragePositionsRevertPartialUpdateRaw(requestParameters: V1LogisticsStoragePositionsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStoragePosition>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsStoragePositionsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/storage_positions/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedStoragePositionRequestToJSON(requestParameters['aPIPatchedStoragePositionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStoragePositionFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStoragePositionsRevertPartialUpdate(requestParameters: V1LogisticsStoragePositionsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStoragePosition> {
        const response = await this.v1LogisticsStoragePositionsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStoragePositionsVersionsRetrieveRaw(requestParameters: V1LogisticsStoragePositionsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStoragePosition>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1LogisticsStoragePositionsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/logistics/storage_positions/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStoragePositionFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1LogisticsStoragePositionsVersionsRetrieve(requestParameters: V1LogisticsStoragePositionsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStoragePosition> {
        const response = await this.v1LogisticsStoragePositionsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationBillingAddressCompareVersionsCreateRaw(requestParameters: V1OrganizationsOrganizationBillingAddressCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1OrganizationsOrganizationBillingAddressCompareVersionsCreate().'
            );
        }

        if (requestParameters['organizationPk'] == null) {
            throw new runtime.RequiredError(
                'organizationPk',
                'Required parameter "organizationPk" was null or undefined when calling v1OrganizationsOrganizationBillingAddressCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIAddressRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAddressRequest',
                'Required parameter "aPIAddressRequest" was null or undefined when calling v1OrganizationsOrganizationBillingAddressCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/organizations/organization/{organization_pk}/billing_address/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"organization_pk"}}`, encodeURIComponent(String(requestParameters['organizationPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAddressRequestToJSON(requestParameters['aPIAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationBillingAddressCompareVersionsCreate(requestParameters: V1OrganizationsOrganizationBillingAddressCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1OrganizationsOrganizationBillingAddressCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationBillingAddressRevertPartialUpdateRaw(requestParameters: V1OrganizationsOrganizationBillingAddressRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1OrganizationsOrganizationBillingAddressRevertPartialUpdate().'
            );
        }

        if (requestParameters['organizationPk'] == null) {
            throw new runtime.RequiredError(
                'organizationPk',
                'Required parameter "organizationPk" was null or undefined when calling v1OrganizationsOrganizationBillingAddressRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/organizations/organization/{organization_pk}/billing_address/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"organization_pk"}}`, encodeURIComponent(String(requestParameters['organizationPk']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedAddressRequestToJSON(requestParameters['aPIPatchedAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationBillingAddressRevertPartialUpdate(requestParameters: V1OrganizationsOrganizationBillingAddressRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1OrganizationsOrganizationBillingAddressRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationBillingAddressVersionsRetrieveRaw(requestParameters: V1OrganizationsOrganizationBillingAddressVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1OrganizationsOrganizationBillingAddressVersionsRetrieve().'
            );
        }

        if (requestParameters['organizationPk'] == null) {
            throw new runtime.RequiredError(
                'organizationPk',
                'Required parameter "organizationPk" was null or undefined when calling v1OrganizationsOrganizationBillingAddressVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/organizations/organization/{organization_pk}/billing_address/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"organization_pk"}}`, encodeURIComponent(String(requestParameters['organizationPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationBillingAddressVersionsRetrieve(requestParameters: V1OrganizationsOrganizationBillingAddressVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1OrganizationsOrganizationBillingAddressVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationCompareVersionsCreateRaw(requestParameters: V1OrganizationsOrganizationCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOrganization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1OrganizationsOrganizationCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIOrganizationRequest',
                'Required parameter "aPIOrganizationRequest" was null or undefined when calling v1OrganizationsOrganizationCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/organizations/organization/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIOrganizationRequestToJSON(requestParameters['aPIOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOrganizationFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationCompareVersionsCreate(requestParameters: V1OrganizationsOrganizationCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOrganization> {
        const response = await this.v1OrganizationsOrganizationCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationRevertPartialUpdateRaw(requestParameters: V1OrganizationsOrganizationRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOrganization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1OrganizationsOrganizationRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/organizations/organization/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedOrganizationRequestToJSON(requestParameters['aPIPatchedOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOrganizationFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationRevertPartialUpdate(requestParameters: V1OrganizationsOrganizationRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOrganization> {
        const response = await this.v1OrganizationsOrganizationRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationShippingAddressCompareVersionsCreateRaw(requestParameters: V1OrganizationsOrganizationShippingAddressCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1OrganizationsOrganizationShippingAddressCompareVersionsCreate().'
            );
        }

        if (requestParameters['organizationPk'] == null) {
            throw new runtime.RequiredError(
                'organizationPk',
                'Required parameter "organizationPk" was null or undefined when calling v1OrganizationsOrganizationShippingAddressCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIAddressRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAddressRequest',
                'Required parameter "aPIAddressRequest" was null or undefined when calling v1OrganizationsOrganizationShippingAddressCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/organizations/organization/{organization_pk}/shipping_address/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"organization_pk"}}`, encodeURIComponent(String(requestParameters['organizationPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAddressRequestToJSON(requestParameters['aPIAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationShippingAddressCompareVersionsCreate(requestParameters: V1OrganizationsOrganizationShippingAddressCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1OrganizationsOrganizationShippingAddressCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationShippingAddressRevertPartialUpdateRaw(requestParameters: V1OrganizationsOrganizationShippingAddressRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1OrganizationsOrganizationShippingAddressRevertPartialUpdate().'
            );
        }

        if (requestParameters['organizationPk'] == null) {
            throw new runtime.RequiredError(
                'organizationPk',
                'Required parameter "organizationPk" was null or undefined when calling v1OrganizationsOrganizationShippingAddressRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/organizations/organization/{organization_pk}/shipping_address/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"organization_pk"}}`, encodeURIComponent(String(requestParameters['organizationPk']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedAddressRequestToJSON(requestParameters['aPIPatchedAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationShippingAddressRevertPartialUpdate(requestParameters: V1OrganizationsOrganizationShippingAddressRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1OrganizationsOrganizationShippingAddressRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationShippingAddressVersionsRetrieveRaw(requestParameters: V1OrganizationsOrganizationShippingAddressVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1OrganizationsOrganizationShippingAddressVersionsRetrieve().'
            );
        }

        if (requestParameters['organizationPk'] == null) {
            throw new runtime.RequiredError(
                'organizationPk',
                'Required parameter "organizationPk" was null or undefined when calling v1OrganizationsOrganizationShippingAddressVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/organizations/organization/{organization_pk}/shipping_address/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"organization_pk"}}`, encodeURIComponent(String(requestParameters['organizationPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationShippingAddressVersionsRetrieve(requestParameters: V1OrganizationsOrganizationShippingAddressVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1OrganizationsOrganizationShippingAddressVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationVersionsRetrieveRaw(requestParameters: V1OrganizationsOrganizationVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOrganization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1OrganizationsOrganizationVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/organizations/organization/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOrganizationFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1OrganizationsOrganizationVersionsRetrieve(requestParameters: V1OrganizationsOrganizationVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOrganization> {
        const response = await this.v1OrganizationsOrganizationVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * File upload view for the Automated Quote Generation feature (AI Uploader). When used to upload a CAD-file, creates a temporary Request instance and starts up the CAD-file processing pipeline.
     */
    async v1RequestAqgUploadCreateRaw(requestParameters: V1RequestAqgUploadCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['aPIAQGUploadRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAQGUploadRequest',
                'Required parameter "aPIAQGUploadRequest" was null or undefined when calling v1RequestAqgUploadCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/aqg_upload/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAQGUploadRequestToJSON(requestParameters['aPIAQGUploadRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * File upload view for the Automated Quote Generation feature (AI Uploader). When used to upload a CAD-file, creates a temporary Request instance and starts up the CAD-file processing pipeline.
     */
    async v1RequestAqgUploadCreate(requestParameters: V1RequestAqgUploadCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1RequestAqgUploadCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesCompareVersionsCreateRaw(requestParameters: V1RequestFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling v1RequestFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/files/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesCompareVersionsCreate(requestParameters: V1RequestFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesRevertPartialUpdateRaw(requestParameters: V1RequestFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/files/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesRevertPartialUpdate(requestParameters: V1RequestFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesVersionsRetrieveRaw(requestParameters: V1RequestFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/files/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesVersionsRetrieve(requestParameters: V1RequestFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOfferFilesCompareVersionsCreateRaw(requestParameters: V1RequestOfferFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOfferFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestOfferFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['offer'] == null) {
            throw new runtime.RequiredError(
                'offer',
                'Required parameter "offer" was null or undefined when calling v1RequestOfferFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['offer'] != null) {
            formParams.append('offer', requestParameters['offer'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/offer_files/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOfferFilesCompareVersionsCreate(requestParameters: V1RequestOfferFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOfferFile> {
        const response = await this.v1RequestOfferFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOfferFilesRevertPartialUpdateRaw(requestParameters: V1RequestOfferFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOfferFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestOfferFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['offer'] != null) {
            formParams.append('offer', requestParameters['offer'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/offer_files/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOfferFilesRevertPartialUpdate(requestParameters: V1RequestOfferFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOfferFile> {
        const response = await this.v1RequestOfferFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOfferFilesVersionsRetrieveRaw(requestParameters: V1RequestOfferFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOfferFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestOfferFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/offer_files/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOfferFilesVersionsRetrieve(requestParameters: V1RequestOfferFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOfferFile> {
        const response = await this.v1RequestOfferFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersCompareVersionsCreateRaw(requestParameters: V1RequestOffersCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOffer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestOffersCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIOfferRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIOfferRequest',
                'Required parameter "aPIOfferRequest" was null or undefined when calling v1RequestOffersCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/offers/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIOfferRequestToJSON(requestParameters['aPIOfferRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersCompareVersionsCreate(requestParameters: V1RequestOffersCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOffer> {
        const response = await this.v1RequestOffersCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersFilesCompareVersionsCreateRaw(requestParameters: V1RequestOffersFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOfferFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestOffersFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['offerPk'] == null) {
            throw new runtime.RequiredError(
                'offerPk',
                'Required parameter "offerPk" was null or undefined when calling v1RequestOffersFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['offer'] == null) {
            throw new runtime.RequiredError(
                'offer',
                'Required parameter "offer" was null or undefined when calling v1RequestOffersFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['offer'] != null) {
            formParams.append('offer', requestParameters['offer'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/offers/{offer_pk}/files/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"offer_pk"}}`, encodeURIComponent(String(requestParameters['offerPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersFilesCompareVersionsCreate(requestParameters: V1RequestOffersFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOfferFile> {
        const response = await this.v1RequestOffersFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersFilesRevertPartialUpdateRaw(requestParameters: V1RequestOffersFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOfferFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestOffersFilesRevertPartialUpdate().'
            );
        }

        if (requestParameters['offerPk'] == null) {
            throw new runtime.RequiredError(
                'offerPk',
                'Required parameter "offerPk" was null or undefined when calling v1RequestOffersFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['offer'] != null) {
            formParams.append('offer', requestParameters['offer'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/offers/{offer_pk}/files/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"offer_pk"}}`, encodeURIComponent(String(requestParameters['offerPk']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersFilesRevertPartialUpdate(requestParameters: V1RequestOffersFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOfferFile> {
        const response = await this.v1RequestOffersFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersFilesVersionsRetrieveRaw(requestParameters: V1RequestOffersFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOfferFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestOffersFilesVersionsRetrieve().'
            );
        }

        if (requestParameters['offerPk'] == null) {
            throw new runtime.RequiredError(
                'offerPk',
                'Required parameter "offerPk" was null or undefined when calling v1RequestOffersFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/offers/{offer_pk}/files/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"offer_pk"}}`, encodeURIComponent(String(requestParameters['offerPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersFilesVersionsRetrieve(requestParameters: V1RequestOffersFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOfferFile> {
        const response = await this.v1RequestOffersFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersRevertPartialUpdateRaw(requestParameters: V1RequestOffersRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOffer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestOffersRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/offers/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedOfferRequestToJSON(requestParameters['aPIPatchedOfferRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersRevertPartialUpdate(requestParameters: V1RequestOffersRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOffer> {
        const response = await this.v1RequestOffersRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersVersionsRetrieveRaw(requestParameters: V1RequestOffersVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOffer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestOffersVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/offers/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestOffersVersionsRetrieve(requestParameters: V1RequestOffersVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOffer> {
        const response = await this.v1RequestOffersVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1RequestRequestsBomItemsBulkCreateRaw(requestParameters: V1RequestRequestsBomItemsBulkCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsBomItemsBulkCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/bom/items/bulk/`.replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async v1RequestRequestsBomItemsBulkCreate(requestParameters: V1RequestRequestsBomItemsBulkCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1RequestRequestsBomItemsBulkCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsCompareVersionsCreateRaw(requestParameters: V1RequestRequestsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIRequestRequest',
                'Required parameter "aPIRequestRequest" was null or undefined when calling v1RequestRequestsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIRequestRequestToJSON(requestParameters['aPIRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsCompareVersionsCreate(requestParameters: V1RequestRequestsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1RequestRequestsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Completes a temporary Request. This action is required to change the Request state from temporary to persistent. Staff members are only allowed to act on persistent Requests.  Note:     This view *requires* the Request access_secret to be send with the     X-ACCESS-SECRET header in the PATCH-request in order to accept the     request. If the access_secret is not provided or does not match the     access_secret field, the request is rejected.      Also this view/action is only accepted once per temporary Request     (as it will no longer be a temporary, but a persistent Request     after completing the action).
     */
    async v1RequestRequestsCompletePartialUpdateRaw(requestParameters: V1RequestRequestsCompletePartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsCompletePartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{id}/complete/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedRequestRequestToJSON(requestParameters['aPIPatchedRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Completes a temporary Request. This action is required to change the Request state from temporary to persistent. Staff members are only allowed to act on persistent Requests.  Note:     This view *requires* the Request access_secret to be send with the     X-ACCESS-SECRET header in the PATCH-request in order to accept the     request. If the access_secret is not provided or does not match the     access_secret field, the request is rejected.      Also this view/action is only accepted once per temporary Request     (as it will no longer be a temporary, but a persistent Request     after completing the action).
     */
    async v1RequestRequestsCompletePartialUpdate(requestParameters: V1RequestRequestsCompletePartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1RequestRequestsCompletePartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesCompareVersionsCreateRaw(requestParameters: V1RequestRequestsFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsFilesCompareVersionsCreate().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling v1RequestRequestsFilesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/files/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesCompareVersionsCreate(requestParameters: V1RequestRequestsFilesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestRequestsFilesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesRevertPartialUpdateRaw(requestParameters: V1RequestRequestsFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsFilesRevertPartialUpdate().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsFilesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/files/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesRevertPartialUpdate(requestParameters: V1RequestRequestsFilesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestRequestsFilesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesVersionsRetrieveRaw(requestParameters: V1RequestRequestsFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsFilesVersionsRetrieve().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsFilesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/files/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesVersionsRetrieve(requestParameters: V1RequestRequestsFilesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestRequestsFilesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsBulkPartialUpdateRaw(requestParameters: V1RequestRequestsPartsBulkPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPart>> {
        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsBulkPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/bulk/`.replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedPartRequestToJSON(requestParameters['aPIPatchedPartRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartFromJSON(jsonValue));
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsBulkPartialUpdate(requestParameters: V1RequestRequestsPartsBulkPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPart> {
        const response = await this.v1RequestRequestsPartsBulkPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return all articles that are direct children to the specified part (article).
     */
    async v1RequestRequestsPartsChildrenRetrieveRaw(requestParameters: V1RequestRequestsPartsChildrenRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPart>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsPartsChildrenRetrieve().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsChildrenRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/{id}/children/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartFromJSON(jsonValue));
    }

    /**
     * Return all articles that are direct children to the specified part (article).
     */
    async v1RequestRequestsPartsChildrenRetrieve(requestParameters: V1RequestRequestsPartsChildrenRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPart> {
        const response = await this.v1RequestRequestsPartsChildrenRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsPriceRetrieveRaw(requestParameters: V1RequestRequestsPartsPriceRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPartEstimatedPrice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsPartsPriceRetrieve().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsPriceRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/{id}/price/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartEstimatedPriceFromJSON(jsonValue));
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsPriceRetrieve(requestParameters: V1RequestRequestsPartsPriceRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPartEstimatedPrice> {
        const response = await this.v1RequestRequestsPartsPriceRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsPriceUpdateRaw(requestParameters: V1RequestRequestsPartsPriceUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPartEstimatedPrice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsPartsPriceUpdate().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsPriceUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/{id}/price/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIPartEstimatedPriceRequestToJSON(requestParameters['aPIPartEstimatedPriceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartEstimatedPriceFromJSON(jsonValue));
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsPriceUpdate(requestParameters: V1RequestRequestsPartsPriceUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPartEstimatedPrice> {
        const response = await this.v1RequestRequestsPartsPriceUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Triggers a price recalculation for the given Part without updating its properties.
     */
    async v1RequestRequestsPartsRecalculateCreateRaw(requestParameters: V1RequestRequestsPartsRecalculateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPart>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsPartsRecalculateCreate().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsRecalculateCreate().'
            );
        }

        if (requestParameters['aPIPartRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIPartRequest',
                'Required parameter "aPIPartRequest" was null or undefined when calling v1RequestRequestsPartsRecalculateCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/{id}/recalculate/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIPartRequestToJSON(requestParameters['aPIPartRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartFromJSON(jsonValue));
    }

    /**
     * Triggers a price recalculation for the given Part without updating its properties.
     */
    async v1RequestRequestsPartsRecalculateCreate(requestParameters: V1RequestRequestsPartsRecalculateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPart> {
        const response = await this.v1RequestRequestsPartsRecalculateCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsSingleRequestRetrieveRaw(requestParameters: V1RequestRequestsPartsSingleRequestRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPart>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsPartsSingleRequestRetrieve().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsPartsSingleRequestRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/parts/{id}/single-request/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPartFromJSON(jsonValue));
    }

    /**
     * A higher level viewset that is responsible for creating articles that are used to hold information about a part of an assembly.  It creates an abstraction over the article and bom models, as it automatically organizes parts (represented by articles) into a BOM.  Main use case:     Automated quote generation for assemblies / parts found in CAD-files.
     */
    async v1RequestRequestsPartsSingleRequestRetrieve(requestParameters: V1RequestRequestsPartsSingleRequestRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPart> {
        const response = await this.v1RequestRequestsPartsSingleRequestRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Publish processing progress updates for temporary Requests (AQG workflow).
     */
    async v1RequestRequestsProcessingStatusCreateRaw(requestParameters: V1RequestRequestsProcessingStatusCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsProcessingStatusCreate().'
            );
        }

        if (requestParameters['aPIRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIRequestRequest',
                'Required parameter "aPIRequestRequest" was null or undefined when calling v1RequestRequestsProcessingStatusCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{id}/processing-status/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIRequestRequestToJSON(requestParameters['aPIRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Publish processing progress updates for temporary Requests (AQG workflow).
     */
    async v1RequestRequestsProcessingStatusCreate(requestParameters: V1RequestRequestsProcessingStatusCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1RequestRequestsProcessingStatusCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsRevertPartialUpdateRaw(requestParameters: V1RequestRequestsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedRequestRequestToJSON(requestParameters['aPIPatchedRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsRevertPartialUpdate(requestParameters: V1RequestRequestsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1RequestRequestsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsVersionsRetrieveRaw(requestParameters: V1RequestRequestsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsVersionsRetrieve(requestParameters: V1RequestRequestsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequest> {
        const response = await this.v1RequestRequestsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1RetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async v1Retrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1RetrieveRaw(initOverrides);
    }

    /**
     * Autocomplete suggestions for role search  Query Parameters: - q: Prefix to search for (optional, if empty returns all roles) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchAccountsRolesAutocompleteRetrieveRaw(requestParameters: V1SearchAccountsRolesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRoleAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/accounts/roles/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRoleAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for role search  Query Parameters: - q: Prefix to search for (optional, if empty returns all roles) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchAccountsRolesAutocompleteRetrieve(requestParameters: V1SearchAccountsRolesAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRoleAutocompleteResponse> {
        const response = await this.v1SearchAccountsRolesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for roles using Elasticsearch
     */
    async v1SearchAccountsRolesRetrieveRaw(requestParameters: V1SearchAccountsRolesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRoleSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchAccountsRolesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['description'] != null) {
            queryParameters['description'] = requestParameters['description'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['isGuestUserRole'] != null) {
            queryParameters['is_guest_user_role'] = requestParameters['isGuestUserRole'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['subRoleIds'] != null) {
            queryParameters['sub_role_ids'] = requestParameters['subRoleIds'];
        }

        if (requestParameters['subRoleNames'] != null) {
            queryParameters['sub_role_names'] = requestParameters['subRoleNames'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/accounts/roles/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRoleSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for roles using Elasticsearch
     */
    async v1SearchAccountsRolesRetrieve(requestParameters: V1SearchAccountsRolesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRoleSearchResponse> {
        const response = await this.v1SearchAccountsRolesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for user search  Query Parameters: - q: Prefix to search for (optional, if empty returns recent/popular users) - size: Number of suggestions to return (default: 5, max: 20) - staff_only: Filter to only staff users (optional, \'true\'/\'false\')  Examples: GET /api/search/accounts/users/autocomplete/?q=john&staff_only=true  (search) GET /api/search/accounts/users/autocomplete/?staff_only=true&size=10 (popular staff)
     */
    async v1SearchAccountsUsersAutocompleteRetrieveRaw(requestParameters: V1SearchAccountsUsersAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIUserAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['staffOnly'] != null) {
            queryParameters['staff_only'] = requestParameters['staffOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/accounts/users/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIUserAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for user search  Query Parameters: - q: Prefix to search for (optional, if empty returns recent/popular users) - size: Number of suggestions to return (default: 5, max: 20) - staff_only: Filter to only staff users (optional, \'true\'/\'false\')  Examples: GET /api/search/accounts/users/autocomplete/?q=john&staff_only=true  (search) GET /api/search/accounts/users/autocomplete/?staff_only=true&size=10 (popular staff)
     */
    async v1SearchAccountsUsersAutocompleteRetrieve(requestParameters: V1SearchAccountsUsersAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIUserAutocompleteResponse> {
        const response = await this.v1SearchAccountsUsersAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for users using Elasticsearch
     */
    async v1SearchAccountsUsersRetrieveRaw(requestParameters: V1SearchAccountsUsersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIUserSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchAccountsUsersRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['comment'] != null) {
            queryParameters['comment'] = requestParameters['comment'];
        }

        if (requestParameters['createdFrom'] != null) {
            queryParameters['created_from'] = requestParameters['createdFrom'];
        }

        if (requestParameters['createdTo'] != null) {
            queryParameters['created_to'] = requestParameters['createdTo'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['guestId'] != null) {
            queryParameters['guest_id'] = requestParameters['guestId'];
        }

        if (requestParameters['guestRepForId'] != null) {
            queryParameters['guest_rep_for_id'] = requestParameters['guestRepForId'];
        }

        if (requestParameters['guestSharepointId'] != null) {
            queryParameters['guest_sharepoint_id'] = requestParameters['guestSharepointId'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['is_active'] = requestParameters['isActive'];
        }

        if (requestParameters['isGuestUser'] != null) {
            queryParameters['is_guest_user'] = requestParameters['isGuestUser'];
        }

        if (requestParameters['isOrgAdmin'] != null) {
            queryParameters['is_org_admin'] = requestParameters['isOrgAdmin'];
        }

        if (requestParameters['isStaff'] != null) {
            queryParameters['is_staff'] = requestParameters['isStaff'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['roleIds'] != null) {
            queryParameters['role_ids'] = requestParameters['roleIds'];
        }

        if (requestParameters['roleNames'] != null) {
            queryParameters['role_names'] = requestParameters['roleNames'];
        }

        if (requestParameters['rootAccountId'] != null) {
            queryParameters['root_account_id'] = requestParameters['rootAccountId'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['userType'] != null) {
            queryParameters['user_type'] = requestParameters['userType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/accounts/users/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIUserSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for users using Elasticsearch
     */
    async v1SearchAccountsUsersRetrieve(requestParameters: V1SearchAccountsUsersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIUserSearchResponse> {
        const response = await this.v1SearchAccountsUsersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for chat messages
     */
    async v1SearchChatMessagesAutocompleteRetrieveRaw(requestParameters: V1SearchChatMessagesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMessageAutocompleteResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchChatMessagesAutocompleteRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/chat/messages/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMessageAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for chat messages
     */
    async v1SearchChatMessagesAutocompleteRetrieve(requestParameters: V1SearchChatMessagesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMessageAutocompleteResponse> {
        const response = await this.v1SearchChatMessagesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for chat messages using Elasticsearch  Query Parameters: - q: Search query string (required) - size: Number of results to return (default: 20, max: 100) - from: Pagination offset (default: 0) - fields: Comma separated list of fields to search (optional) - channel_id: Filter by channel id (optional) - message_type: Filter by message_type (optional) - author_id: Filter by author UUID (optional) - author_email: Filter by author email (optional) - has_event: Filter by presence of event data (optional, bool) - channel_name: Filter by channel name keyword (optional) - created_from / created_to: ISO datetime range filter (optional) - author_types: Filter by author user type (values: guest, org)
     */
    async v1SearchChatMessagesRetrieveRaw(requestParameters: V1SearchChatMessagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMessageSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchChatMessagesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['authorEmail'] != null) {
            queryParameters['author_email'] = requestParameters['authorEmail'];
        }

        if (requestParameters['authorId'] != null) {
            queryParameters['author_id'] = requestParameters['authorId'];
        }

        if (requestParameters['authorTypes'] != null) {
            queryParameters['author_types'] = requestParameters['authorTypes'];
        }

        if (requestParameters['channelId'] != null) {
            queryParameters['channel_id'] = requestParameters['channelId'];
        }

        if (requestParameters['channelName'] != null) {
            queryParameters['channel_name'] = requestParameters['channelName'];
        }

        if (requestParameters['createdFrom'] != null) {
            queryParameters['created_from'] = requestParameters['createdFrom'];
        }

        if (requestParameters['createdTo'] != null) {
            queryParameters['created_to'] = requestParameters['createdTo'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['hasEvent'] != null) {
            queryParameters['has_event'] = requestParameters['hasEvent'];
        }

        if (requestParameters['messageType'] != null) {
            queryParameters['message_type'] = requestParameters['messageType'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/chat/messages/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMessageSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for chat messages using Elasticsearch  Query Parameters: - q: Search query string (required) - size: Number of results to return (default: 20, max: 100) - from: Pagination offset (default: 0) - fields: Comma separated list of fields to search (optional) - channel_id: Filter by channel id (optional) - message_type: Filter by message_type (optional) - author_id: Filter by author UUID (optional) - author_email: Filter by author email (optional) - has_event: Filter by presence of event data (optional, bool) - channel_name: Filter by channel name keyword (optional) - created_from / created_to: ISO datetime range filter (optional) - author_types: Filter by author user type (values: guest, org)
     */
    async v1SearchChatMessagesRetrieve(requestParameters: V1SearchChatMessagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMessageSearchResponse> {
        const response = await this.v1SearchChatMessagesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for contacts  Query Parameters: - q: Prefix to search for (optional, if empty returns recent contacts) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchContactsAutocompleteRetrieveRaw(requestParameters: V1SearchContactsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/contacts/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for contacts  Query Parameters: - q: Prefix to search for (optional, if empty returns recent contacts) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchContactsAutocompleteRetrieve(requestParameters: V1SearchContactsAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactAutocompleteResponse> {
        const response = await this.v1SearchContactsAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for contacts using Elasticsearch
     */
    async v1SearchContactsRetrieveRaw(requestParameters: V1SearchContactsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchContactsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['city'] != null) {
            queryParameters['city'] = requestParameters['city'];
        }

        if (requestParameters['comment'] != null) {
            queryParameters['comment'] = requestParameters['comment'];
        }

        if (requestParameters['country'] != null) {
            queryParameters['country'] = requestParameters['country'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        if (requestParameters['mobile'] != null) {
            queryParameters['mobile'] = requestParameters['mobile'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['phone'] != null) {
            queryParameters['phone'] = requestParameters['phone'];
        }

        if (requestParameters['preferredContactMethod'] != null) {
            queryParameters['preferred_contact_method'] = requestParameters['preferredContactMethod'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/contacts/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for contacts using Elasticsearch
     */
    async v1SearchContactsRetrieve(requestParameters: V1SearchContactsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactSearchResponse> {
        const response = await this.v1SearchContactsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for bill files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - bill_id: Filter by bill ID (optional) - contract_id: Filter by contract ID (optional) - request_id: Filter by request ID (optional) - request_certificate: Filter by request certificate (optional) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchContractsBillFilesRetrieveRaw(requestParameters: V1SearchContractsBillFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBillFileSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchContractsBillFilesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['billId'] != null) {
            queryParameters['bill_id'] = requestParameters['billId'];
        }

        if (requestParameters['contractId'] != null) {
            queryParameters['contract_id'] = requestParameters['contractId'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['fileName'] != null) {
            queryParameters['file_name'] = requestParameters['fileName'];
        }

        if (requestParameters['fileSize'] != null) {
            queryParameters['file_size'] = requestParameters['fileSize'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['requestCertificate'] != null) {
            queryParameters['request_certificate'] = requestParameters['requestCertificate'];
        }

        if (requestParameters['requestId'] != null) {
            queryParameters['request_id'] = requestParameters['requestId'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['storedAt'] != null) {
            queryParameters['stored_at'] = (requestParameters['storedAt'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/contracts/bill-files/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillFileSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for bill files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - bill_id: Filter by bill ID (optional) - contract_id: Filter by contract ID (optional) - request_id: Filter by request ID (optional) - request_certificate: Filter by request certificate (optional) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchContractsBillFilesRetrieve(requestParameters: V1SearchContractsBillFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBillFileSearchResponse> {
        const response = await this.v1SearchContractsBillFilesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for bills  Query Parameters: - q: Prefix to search for (required) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchContractsBillsAutocompleteRetrieveRaw(requestParameters: V1SearchContractsBillsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBillAutocompleteResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchContractsBillsAutocompleteRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/contracts/bills/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for bills  Query Parameters: - q: Prefix to search for (required) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchContractsBillsAutocompleteRetrieve(requestParameters: V1SearchContractsBillsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBillAutocompleteResponse> {
        const response = await this.v1SearchContractsBillsAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for bills using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' for all) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - contract_number: Filter by contract ID (optional) - paid: Filter by paid status (optional, true/false) - due_date_from: Filter bills due from this date (optional, ISO format) - due_date_to: Filter bills due until this date (optional, ISO format) - amount: Filter by exact amount (optional, e.g., 42.50) - amount_min: Filter by minimum amount (optional, ignored if \'amount\' is set) - amount_max: Filter by maximum amount (optional, ignored if \'amount\' is set) - contract_status: Filter by contract status (optional, comma-separated) - request_certificate: Filter by request certificate (optional)
     */
    async v1SearchContractsBillsRetrieveRaw(requestParameters: V1SearchContractsBillsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBillSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchContractsBillsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['amount'] != null) {
            queryParameters['amount'] = requestParameters['amount'];
        }

        if (requestParameters['amountMax'] != null) {
            queryParameters['amount_max'] = requestParameters['amountMax'];
        }

        if (requestParameters['amountMin'] != null) {
            queryParameters['amount_min'] = requestParameters['amountMin'];
        }

        if (requestParameters['billNumber'] != null) {
            queryParameters['bill_number'] = requestParameters['billNumber'];
        }

        if (requestParameters['contractNumber'] != null) {
            queryParameters['contract_number'] = requestParameters['contractNumber'];
        }

        if (requestParameters['contractStatus'] != null) {
            queryParameters['contract_status'] = requestParameters['contractStatus'];
        }

        if (requestParameters['createdAt'] != null) {
            queryParameters['created_at'] = requestParameters['createdAt'];
        }

        if (requestParameters['dueDate'] != null) {
            queryParameters['due_date'] = (requestParameters['dueDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['editorId'] != null) {
            queryParameters['editor_id'] = requestParameters['editorId'];
        }

        if (requestParameters['editors'] != null) {
            queryParameters['editors'] = requestParameters['editors'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['paid'] != null) {
            queryParameters['paid'] = requestParameters['paid'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['requestCertificate'] != null) {
            queryParameters['request_certificate'] = requestParameters['requestCertificate'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/contracts/bills/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBillSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for bills using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' for all) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - contract_number: Filter by contract ID (optional) - paid: Filter by paid status (optional, true/false) - due_date_from: Filter bills due from this date (optional, ISO format) - due_date_to: Filter bills due until this date (optional, ISO format) - amount: Filter by exact amount (optional, e.g., 42.50) - amount_min: Filter by minimum amount (optional, ignored if \'amount\' is set) - amount_max: Filter by maximum amount (optional, ignored if \'amount\' is set) - contract_status: Filter by contract status (optional, comma-separated) - request_certificate: Filter by request certificate (optional)
     */
    async v1SearchContractsBillsRetrieve(requestParameters: V1SearchContractsBillsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBillSearchResponse> {
        const response = await this.v1SearchContractsBillsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for contract files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - contract_id: Filter by contract ID (optional) - request_id: Filter by request ID (optional) - request_certificate: Filter by request certificate (optional) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchContractsContractFilesRetrieveRaw(requestParameters: V1SearchContractsContractFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContractFileSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchContractsContractFilesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contractId'] != null) {
            queryParameters['contract_id'] = requestParameters['contractId'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['fileName'] != null) {
            queryParameters['file_name'] = requestParameters['fileName'];
        }

        if (requestParameters['fileSize'] != null) {
            queryParameters['file_size'] = requestParameters['fileSize'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['requestCertificate'] != null) {
            queryParameters['request_certificate'] = requestParameters['requestCertificate'];
        }

        if (requestParameters['requestId'] != null) {
            queryParameters['request_id'] = requestParameters['requestId'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['storedAt'] != null) {
            queryParameters['stored_at'] = (requestParameters['storedAt'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/contracts/contract-files/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractFileSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for contract files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - contract_id: Filter by contract ID (optional) - request_id: Filter by request ID (optional) - request_certificate: Filter by request certificate (optional) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchContractsContractFilesRetrieve(requestParameters: V1SearchContractsContractFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContractFileSearchResponse> {
        const response = await this.v1SearchContractsContractFilesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for contract search
     */
    async v1SearchContractsContractsAutocompleteRetrieveRaw(requestParameters: V1SearchContractsContractsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContractAutocompleteResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchContractsContractsAutocompleteRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/contracts/contracts/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for contract search
     */
    async v1SearchContractsContractsAutocompleteRetrieve(requestParameters: V1SearchContractsContractsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContractAutocompleteResponse> {
        const response = await this.v1SearchContractsContractsAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for contracts using Elasticsearch
     */
    async v1SearchContractsContractsRetrieveRaw(requestParameters: V1SearchContractsContractsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContractSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchContractsContractsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['article'] != null) {
            queryParameters['article'] = requestParameters['article'];
        }

        if (requestParameters['articleNumber'] != null) {
            queryParameters['article_number'] = requestParameters['articleNumber'];
        }

        if (requestParameters['billingAddress'] != null) {
            queryParameters['billing_address'] = requestParameters['billingAddress'];
        }

        if (requestParameters['comment'] != null) {
            queryParameters['comment'] = requestParameters['comment'];
        }

        if (requestParameters['contractNumber'] != null) {
            queryParameters['contract_number'] = requestParameters['contractNumber'];
        }

        if (requestParameters['createdAt'] != null) {
            queryParameters['created_at'] = requestParameters['createdAt'];
        }

        if (requestParameters['desiredDelivery'] != null) {
            queryParameters['desired_delivery'] = (requestParameters['desiredDelivery'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['editorId'] != null) {
            queryParameters['editor_id'] = requestParameters['editorId'];
        }

        if (requestParameters['editors'] != null) {
            queryParameters['editors'] = requestParameters['editors'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['lastModifiedAt'] != null) {
            queryParameters['last_modified_at'] = requestParameters['lastModifiedAt'];
        }

        if (requestParameters['latestDelivery'] != null) {
            queryParameters['latest_delivery'] = (requestParameters['latestDelivery'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['offerId'] != null) {
            queryParameters['offer_id'] = requestParameters['offerId'];
        }

        if (requestParameters['offerNumber'] != null) {
            queryParameters['offer_number'] = requestParameters['offerNumber'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['price'] != null) {
            queryParameters['price'] = requestParameters['price'];
        }

        if (requestParameters['priorityShipping'] != null) {
            queryParameters['priority_shipping'] = requestParameters['priorityShipping'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['requestCertificate'] != null) {
            queryParameters['request_certificate'] = requestParameters['requestCertificate'];
        }

        if (requestParameters['requestId'] != null) {
            queryParameters['request_id'] = requestParameters['requestId'];
        }

        if (requestParameters['requestStatus'] != null) {
            queryParameters['request_status'] = requestParameters['requestStatus'];
        }

        if (requestParameters['shippingAddress'] != null) {
            queryParameters['shipping_address'] = requestParameters['shippingAddress'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/contracts/contracts/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContractSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for contracts using Elasticsearch
     */
    async v1SearchContractsContractsRetrieve(requestParameters: V1SearchContractsContractsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContractSearchResponse> {
        const response = await this.v1SearchContractsContractsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for customers  Query Parameters: - q: Prefix to search for (optional, if empty returns recent customers) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchCustomersCustomersAutocompleteRetrieveRaw(requestParameters: V1SearchCustomersCustomersAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APICustomerAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/customers/customers/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APICustomerAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for customers  Query Parameters: - q: Prefix to search for (optional, if empty returns recent customers) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchCustomersCustomersAutocompleteRetrieve(requestParameters: V1SearchCustomersCustomersAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APICustomerAutocompleteResponse> {
        const response = await this.v1SearchCustomersCustomersAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for customers using Elasticsearch
     */
    async v1SearchCustomersCustomersRetrieveRaw(requestParameters: V1SearchCustomersCustomersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APICustomerSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchCustomersCustomersRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contactEmail'] != null) {
            queryParameters['contact_email'] = requestParameters['contactEmail'];
        }

        if (requestParameters['contactName'] != null) {
            queryParameters['contact_name'] = requestParameters['contactName'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['ustId'] != null) {
            queryParameters['ust_id'] = requestParameters['ustId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/customers/customers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APICustomerSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for customers using Elasticsearch
     */
    async v1SearchCustomersCustomersRetrieve(requestParameters: V1SearchCustomersCustomersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APICustomerSearchResponse> {
        const response = await this.v1SearchCustomersCustomersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for guest request files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - guest_request_id: Filter by guest request ID (optional) - file_type: Filter by file type (optional) - file_name: Filter by file name (optional, partial match) - created_at: Filter by created date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchGuestRequestsGuestRequestFilesRetrieveRaw(requestParameters: V1SearchGuestRequestsGuestRequestFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIGuestRequestFileSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchGuestRequestsGuestRequestFilesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAt'] != null) {
            queryParameters['created_at'] = (requestParameters['createdAt'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['fileName'] != null) {
            queryParameters['file_name'] = requestParameters['fileName'];
        }

        if (requestParameters['fileSize'] != null) {
            queryParameters['file_size'] = requestParameters['fileSize'];
        }

        if (requestParameters['fileType'] != null) {
            queryParameters['file_type'] = requestParameters['fileType'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['guestRequestId'] != null) {
            queryParameters['guest_request_id'] = requestParameters['guestRequestId'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/guest-requests/guest-request-files/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIGuestRequestFileSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for guest request files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - guest_request_id: Filter by guest request ID (optional) - file_type: Filter by file type (optional) - file_name: Filter by file name (optional, partial match) - created_at: Filter by created date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchGuestRequestsGuestRequestFilesRetrieve(requestParameters: V1SearchGuestRequestsGuestRequestFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIGuestRequestFileSearchResponse> {
        const response = await this.v1SearchGuestRequestsGuestRequestFilesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for guest requests
     */
    async v1SearchGuestRequestsGuestRequestsAutocompleteRetrieveRaw(requestParameters: V1SearchGuestRequestsGuestRequestsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIGuestRequestAutocompleteResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchGuestRequestsGuestRequestsAutocompleteRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/guest-requests/guest_requests/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIGuestRequestAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for guest requests
     */
    async v1SearchGuestRequestsGuestRequestsAutocompleteRetrieve(requestParameters: V1SearchGuestRequestsGuestRequestsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIGuestRequestAutocompleteResponse> {
        const response = await this.v1SearchGuestRequestsGuestRequestsAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for guest requests using Elasticsearch
     */
    async v1SearchGuestRequestsGuestRequestsRetrieveRaw(requestParameters: V1SearchGuestRequestsGuestRequestsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIGuestRequestSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchGuestRequestsGuestRequestsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['company'] != null) {
            queryParameters['company'] = requestParameters['company'];
        }

        if (requestParameters['createdDate'] != null) {
            queryParameters['created_date'] = (requestParameters['createdDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['description'] != null) {
            queryParameters['description'] = requestParameters['description'];
        }

        if (requestParameters['editors'] != null) {
            queryParameters['editors'] = requestParameters['editors'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['hasFiles'] != null) {
            queryParameters['has_files'] = requestParameters['hasFiles'];
        }

        if (requestParameters['isTemp'] != null) {
            queryParameters['is_temp'] = requestParameters['isTemp'];
        }

        if (requestParameters['material'] != null) {
            queryParameters['material'] = requestParameters['material'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['phone'] != null) {
            queryParameters['phone'] = requestParameters['phone'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['quantity'] != null) {
            queryParameters['quantity'] = requestParameters['quantity'];
        }

        if (requestParameters['readById'] != null) {
            queryParameters['read_by_id'] = requestParameters['readById'];
        }

        if (requestParameters['requestNumber'] != null) {
            queryParameters['request_number'] = requestParameters['requestNumber'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['updatedDate'] != null) {
            queryParameters['updated_date'] = (requestParameters['updatedDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/guest-requests/guest_requests/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIGuestRequestSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for guest requests using Elasticsearch
     */
    async v1SearchGuestRequestsGuestRequestsRetrieve(requestParameters: V1SearchGuestRequestsGuestRequestsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIGuestRequestSearchResponse> {
        const response = await this.v1SearchGuestRequestsGuestRequestsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for article files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - article_id: Filter by article ID (optional) - article_number: Filter by article number (optional) - article_name: Filter by article name (optional, partial match) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchItemsArticleFilesRetrieveRaw(requestParameters: V1SearchItemsArticleFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleFileSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchItemsArticleFilesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['articleId'] != null) {
            queryParameters['article_id'] = requestParameters['articleId'];
        }

        if (requestParameters['articleName'] != null) {
            queryParameters['article_name'] = requestParameters['articleName'];
        }

        if (requestParameters['articleNumber'] != null) {
            queryParameters['article_number'] = requestParameters['articleNumber'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['fileName'] != null) {
            queryParameters['file_name'] = requestParameters['fileName'];
        }

        if (requestParameters['fileSize'] != null) {
            queryParameters['file_size'] = requestParameters['fileSize'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['storedAt'] != null) {
            queryParameters['stored_at'] = (requestParameters['storedAt'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/article-files/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFileSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for article files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - article_id: Filter by article ID (optional) - article_number: Filter by article number (optional) - article_name: Filter by article name (optional, partial match) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchItemsArticleFilesRetrieve(requestParameters: V1SearchItemsArticleFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleFileSearchResponse> {
        const response = await this.v1SearchItemsArticleFilesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for article type names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular types) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/article-types/autocomplete/?q=Schr&size=5  (search) GET /api/search/items/article-types/autocomplete/?size=10         (popular types)
     */
    async v1SearchItemsArticleTypesAutocompleteRetrieveRaw(requestParameters: V1SearchItemsArticleTypesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APINamedAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/article-types/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APINamedAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for article type names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular types) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/article-types/autocomplete/?q=Schr&size=5  (search) GET /api/search/items/article-types/autocomplete/?size=10         (popular types)
     */
    async v1SearchItemsArticleTypesAutocompleteRetrieve(requestParameters: V1SearchItemsArticleTypesAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APINamedAutocompleteResponse> {
        const response = await this.v1SearchItemsArticleTypesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for article names and numbers  Query Parameters: - q: Prefix to search for (optional, if empty returns recent articles) - size: Number of suggestions to return (default: 5, max: 20)  Examples: GET /api/search/articles/autocomplete/?q=Schr&size=5  (search) GET /api/search/articles/autocomplete/?size=10        (recent/popular)
     */
    async v1SearchItemsArticlesAutocompleteRetrieveRaw(requestParameters: V1SearchItemsArticlesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/articles/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for article names and numbers  Query Parameters: - q: Prefix to search for (optional, if empty returns recent articles) - size: Number of suggestions to return (default: 5, max: 20)  Examples: GET /api/search/articles/autocomplete/?q=Schr&size=5  (search) GET /api/search/articles/autocomplete/?size=10        (recent/popular)
     */
    async v1SearchItemsArticlesAutocompleteRetrieve(requestParameters: V1SearchItemsArticlesAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAutocompleteResponse> {
        const response = await this.v1SearchItemsArticlesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for articles within a BOM tree structure and return all paths from BOM base to matches.  Query Parameters: - q: Search query string (required, use \'*\' to match all) - bom_base_id: Article ID of the BOM base (required) - name: Filter by article name (optional, partial match) - number: Filter by article number (optional, partial match) - description: Filter by description (optional, partial match) - size: Maximum number of matching articles to return (default: 100, max: 500)  Returns: {     \"total\": <number of matching articles>,     \"results\": [         {             \"article_id\": <article ID>,             \"article\": <article data>,             \"paths\": [                 [<parent_id>, <parent_id>, ..., <match_id>],  // Path from base to match                 ...  // Multiple paths if article appears in multiple locations             ]         },         ...     ] }  Example: GET /api/search/articles/bom-search/?q=screw&bom_base_id=123
     */
    async v1SearchItemsArticlesBomSearchRetrieveRaw(requestParameters: V1SearchItemsArticlesBomSearchRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBomTreeResponse>> {
        if (requestParameters['bomBaseId'] == null) {
            throw new runtime.RequiredError(
                'bomBaseId',
                'Required parameter "bomBaseId" was null or undefined when calling v1SearchItemsArticlesBomSearchRetrieve().'
            );
        }

        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchItemsArticlesBomSearchRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['amount'] != null) {
            queryParameters['amount'] = requestParameters['amount'];
        }

        if (requestParameters['bomBaseId'] != null) {
            queryParameters['bom_base_id'] = requestParameters['bomBaseId'];
        }

        if (requestParameters['createdAt'] != null) {
            queryParameters['created_at'] = requestParameters['createdAt'];
        }

        if (requestParameters['description'] != null) {
            queryParameters['description'] = requestParameters['description'];
        }

        if (requestParameters['manufacturingProcess'] != null) {
            queryParameters['manufacturing_process'] = requestParameters['manufacturingProcess'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['number'] != null) {
            queryParameters['number'] = requestParameters['number'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/articles/bom-search/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBomTreeResponseFromJSON(jsonValue));
    }

    /**
     * Search for articles within a BOM tree structure and return all paths from BOM base to matches.  Query Parameters: - q: Search query string (required, use \'*\' to match all) - bom_base_id: Article ID of the BOM base (required) - name: Filter by article name (optional, partial match) - number: Filter by article number (optional, partial match) - description: Filter by description (optional, partial match) - size: Maximum number of matching articles to return (default: 100, max: 500)  Returns: {     \"total\": <number of matching articles>,     \"results\": [         {             \"article_id\": <article ID>,             \"article\": <article data>,             \"paths\": [                 [<parent_id>, <parent_id>, ..., <match_id>],  // Path from base to match                 ...  // Multiple paths if article appears in multiple locations             ]         },         ...     ] }  Example: GET /api/search/articles/bom-search/?q=screw&bom_base_id=123
     */
    async v1SearchItemsArticlesBomSearchRetrieve(requestParameters: V1SearchItemsArticlesBomSearchRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBomTreeResponse> {
        const response = await this.v1SearchItemsArticlesBomSearchRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for articles using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - name: Filter by article name (optional, partial match - case-insensitive substring search) - brand: Filter by brand name (optional, partial match with wildcards) - category: Filter by category name (optional, partial match - case-insensitive substring search) - type: Filter by article type name (optional) - family: Filter by family name (optional) - is_bom_base: Filter by is_bom_base boolean (optional) - number: Filter by article number (optional, partial match) - description: Filter by description (optional, partial match - case-insensitive substring search) - barcode: Search by barcode VALUE (optional, partial match, e.g. \"2789-8107-2159\") - barcode_text: Search by barcode VALUE (optional, partial match, alias for \'barcode\') - barcode_type: Filter by barcode TYPE name (optional, exact match, e.g. \"QR Code\", \"EAN-13\") - weight: Filter by weight value (optional) - length: Filter by length value (optional) - width: Filter by width value (optional) - height: Filter by height value (optional) - volume: Filter by volume value (optional) - properties: Filter by property name (optional, partial match - case-insensitive substring search) - is_active: Filter by active status (optional, \'true\'/\'false\') - variation_of: Filter by variation_of article ID (optional) - supplier: Filter by supplier name (optional, partial match with wildcards) - country_of_origin: Filter by country of origin (optional, partial match with wildcards) - created_at: Filter by created at date (optional, format: YYYY-MM-DD or ISO datetime) - material: Filter by material name (optional, partial match, case-insensitive) - organization: Filter by organization name (optional, staff-only, partial match, case-insensitive) - request_id: Filter by request ID (optional, staff-only, exact match)  Example: GET /api/search/articles/?q=Schraube&size=10&brand=IKEA GET /api/search/articles/?q=*&weight=100&size=20 GET /api/search/articles/?q=*&name=Hamm               # Partial match (finds \"Hammer\", \"Hammer Handle\", etc.) GET /api/search/articles/?q=*&description=tool        # Partial match in description GET /api/search/articles/?q=*&barcode=2789-8107-2159  # Search by barcode value GET /api/search/articles/?q=*&barcode_type=QR Code    # Filter by barcode type name GET /api/search/articles/?q=*&country_of_origin=Denma # Partial match (finds \"Denmark\") GET /api/search/articles/?q=*&brand=Mendoza-Ag        # Partial match (finds \"Mendoza-Aguilar\") GET /api/search/articles/?q=*&created_at=2025-11-03 # Filter by created at date
     */
    async v1SearchItemsArticlesRetrieveRaw(requestParameters: V1SearchItemsArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticleSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchItemsArticlesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['barcode'] != null) {
            queryParameters['barcode'] = requestParameters['barcode'];
        }

        if (requestParameters['barcodeText'] != null) {
            queryParameters['barcode_text'] = requestParameters['barcodeText'];
        }

        if (requestParameters['barcodeType'] != null) {
            queryParameters['barcode_type'] = requestParameters['barcodeType'];
        }

        if (requestParameters['brand'] != null) {
            queryParameters['brand'] = requestParameters['brand'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        if (requestParameters['countryOfOrigin'] != null) {
            queryParameters['country_of_origin'] = requestParameters['countryOfOrigin'];
        }

        if (requestParameters['createdAt'] != null) {
            queryParameters['created_at'] = requestParameters['createdAt'];
        }

        if (requestParameters['description'] != null) {
            queryParameters['description'] = requestParameters['description'];
        }

        if (requestParameters['family'] != null) {
            queryParameters['family'] = requestParameters['family'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['height'] != null) {
            queryParameters['height'] = requestParameters['height'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['is_active'] = requestParameters['isActive'];
        }

        if (requestParameters['isBomBase'] != null) {
            queryParameters['is_bom_base'] = requestParameters['isBomBase'];
        }

        if (requestParameters['length'] != null) {
            queryParameters['length'] = requestParameters['length'];
        }

        if (requestParameters['material'] != null) {
            queryParameters['material'] = requestParameters['material'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['number'] != null) {
            queryParameters['number'] = requestParameters['number'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['properties'] != null) {
            queryParameters['properties'] = requestParameters['properties'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['requestId'] != null) {
            queryParameters['request_id'] = requestParameters['requestId'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['supplier'] != null) {
            queryParameters['supplier'] = requestParameters['supplier'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['variationOf'] != null) {
            queryParameters['variation_of'] = requestParameters['variationOf'];
        }

        if (requestParameters['volume'] != null) {
            queryParameters['volume'] = requestParameters['volume'];
        }

        if (requestParameters['weight'] != null) {
            queryParameters['weight'] = requestParameters['weight'];
        }

        if (requestParameters['width'] != null) {
            queryParameters['width'] = requestParameters['width'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/articles/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for articles using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - name: Filter by article name (optional, partial match - case-insensitive substring search) - brand: Filter by brand name (optional, partial match with wildcards) - category: Filter by category name (optional, partial match - case-insensitive substring search) - type: Filter by article type name (optional) - family: Filter by family name (optional) - is_bom_base: Filter by is_bom_base boolean (optional) - number: Filter by article number (optional, partial match) - description: Filter by description (optional, partial match - case-insensitive substring search) - barcode: Search by barcode VALUE (optional, partial match, e.g. \"2789-8107-2159\") - barcode_text: Search by barcode VALUE (optional, partial match, alias for \'barcode\') - barcode_type: Filter by barcode TYPE name (optional, exact match, e.g. \"QR Code\", \"EAN-13\") - weight: Filter by weight value (optional) - length: Filter by length value (optional) - width: Filter by width value (optional) - height: Filter by height value (optional) - volume: Filter by volume value (optional) - properties: Filter by property name (optional, partial match - case-insensitive substring search) - is_active: Filter by active status (optional, \'true\'/\'false\') - variation_of: Filter by variation_of article ID (optional) - supplier: Filter by supplier name (optional, partial match with wildcards) - country_of_origin: Filter by country of origin (optional, partial match with wildcards) - created_at: Filter by created at date (optional, format: YYYY-MM-DD or ISO datetime) - material: Filter by material name (optional, partial match, case-insensitive) - organization: Filter by organization name (optional, staff-only, partial match, case-insensitive) - request_id: Filter by request ID (optional, staff-only, exact match)  Example: GET /api/search/articles/?q=Schraube&size=10&brand=IKEA GET /api/search/articles/?q=*&weight=100&size=20 GET /api/search/articles/?q=*&name=Hamm               # Partial match (finds \"Hammer\", \"Hammer Handle\", etc.) GET /api/search/articles/?q=*&description=tool        # Partial match in description GET /api/search/articles/?q=*&barcode=2789-8107-2159  # Search by barcode value GET /api/search/articles/?q=*&barcode_type=QR Code    # Filter by barcode type name GET /api/search/articles/?q=*&country_of_origin=Denma # Partial match (finds \"Denmark\") GET /api/search/articles/?q=*&brand=Mendoza-Ag        # Partial match (finds \"Mendoza-Aguilar\") GET /api/search/articles/?q=*&created_at=2025-11-03 # Filter by created at date
     */
    async v1SearchItemsArticlesRetrieve(requestParameters: V1SearchItemsArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticleSearchResponse> {
        const response = await this.v1SearchItemsArticlesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for barcode type names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular types) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/barcode-types/autocomplete/?q=QR&size=5  (search) GET /api/search/items/barcode-types/autocomplete/?size=10      (popular types)
     */
    async v1SearchItemsBarcodeTypesAutocompleteRetrieveRaw(requestParameters: V1SearchItemsBarcodeTypesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APINamedAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/barcode-types/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APINamedAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for barcode type names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular types) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/barcode-types/autocomplete/?q=QR&size=5  (search) GET /api/search/items/barcode-types/autocomplete/?size=10      (popular types)
     */
    async v1SearchItemsBarcodeTypesAutocompleteRetrieve(requestParameters: V1SearchItemsBarcodeTypesAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APINamedAutocompleteResponse> {
        const response = await this.v1SearchItemsBarcodeTypesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for brand names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular brands) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/brands/autocomplete/?q=IKE&size=5  (search) GET /api/search/items/brands/autocomplete/?size=10        (popular brands)
     */
    async v1SearchItemsBrandsAutocompleteRetrieveRaw(requestParameters: V1SearchItemsBrandsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APINamedAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/brands/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APINamedAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for brand names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular brands) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/brands/autocomplete/?q=IKE&size=5  (search) GET /api/search/items/brands/autocomplete/?size=10        (popular brands)
     */
    async v1SearchItemsBrandsAutocompleteRetrieve(requestParameters: V1SearchItemsBrandsAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APINamedAutocompleteResponse> {
        const response = await this.v1SearchItemsBrandsAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for category names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular categories) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/categories/autocomplete/?q=elec&size=5  (search) GET /api/search/items/categories/autocomplete/?size=10        (popular categories)
     */
    async v1SearchItemsCategoriesAutocompleteRetrieveRaw(requestParameters: V1SearchItemsCategoriesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APINamedAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/categories/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APINamedAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for category names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular categories) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/categories/autocomplete/?q=elec&size=5  (search) GET /api/search/items/categories/autocomplete/?size=10        (popular categories)
     */
    async v1SearchItemsCategoriesAutocompleteRetrieve(requestParameters: V1SearchItemsCategoriesAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APINamedAutocompleteResponse> {
        const response = await this.v1SearchItemsCategoriesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for family names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular families) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/families/autocomplete/?q=Met&size=5  (search) GET /api/search/items/families/autocomplete/?size=10        (popular families)
     */
    async v1SearchItemsFamiliesAutocompleteRetrieveRaw(requestParameters: V1SearchItemsFamiliesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APINamedAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/families/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APINamedAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for family names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular families) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/families/autocomplete/?q=Met&size=5  (search) GET /api/search/items/families/autocomplete/?size=10        (popular families)
     */
    async v1SearchItemsFamiliesAutocompleteRetrieve(requestParameters: V1SearchItemsFamiliesAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APINamedAutocompleteResponse> {
        const response = await this.v1SearchItemsFamiliesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for property names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular properties) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/properties/autocomplete/?q=col&size=5  (search) GET /api/search/items/properties/autocomplete/?size=10       (popular properties)
     */
    async v1SearchItemsPropertiesAutocompleteRetrieveRaw(requestParameters: V1SearchItemsPropertiesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APINamedAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/items/properties/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APINamedAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for property names  Query Parameters: - q: Prefix to search for (optional, if empty returns popular properties) - size: Number of suggestions to return (default: 10, max: 20)  Examples: GET /api/search/items/properties/autocomplete/?q=col&size=5  (search) GET /api/search/items/properties/autocomplete/?size=10       (popular properties)
     */
    async v1SearchItemsPropertiesAutocompleteRetrieve(requestParameters: V1SearchItemsPropertiesAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APINamedAutocompleteResponse> {
        const response = await this.v1SearchItemsPropertiesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for storage articles
     */
    async v1SearchLogisticsStorageArticlesAutocompleteRetrieveRaw(requestParameters: V1SearchLogisticsStorageArticlesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStorageArticleAutocompleteResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchLogisticsStorageArticlesAutocompleteRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/logistics/storage-articles/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStorageArticleAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for storage articles
     */
    async v1SearchLogisticsStorageArticlesAutocompleteRetrieve(requestParameters: V1SearchLogisticsStorageArticlesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStorageArticleAutocompleteResponse> {
        const response = await this.v1SearchLogisticsStorageArticlesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for storage articles using Elasticsearch
     */
    async v1SearchLogisticsStorageArticlesRetrieveRaw(requestParameters: V1SearchLogisticsStorageArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIStorageArticleSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchLogisticsStorageArticlesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['articleNumber'] != null) {
            queryParameters['article_number'] = requestParameters['articleNumber'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['guestEmail'] != null) {
            queryParameters['guest_email'] = requestParameters['guestEmail'];
        }

        if (requestParameters['guestRequestId'] != null) {
            queryParameters['guest_request_id'] = requestParameters['guestRequestId'];
        }

        if (requestParameters['maxAmount'] != null) {
            queryParameters['max_amount'] = requestParameters['maxAmount'];
        }

        if (requestParameters['minAmount'] != null) {
            queryParameters['min_amount'] = requestParameters['minAmount'];
        }

        if (requestParameters['position'] != null) {
            queryParameters['position'] = requestParameters['position'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['sharedRequestId'] != null) {
            queryParameters['shared_request_id'] = requestParameters['sharedRequestId'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/logistics/storage-articles/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIStorageArticleSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for storage articles using Elasticsearch
     */
    async v1SearchLogisticsStorageArticlesRetrieve(requestParameters: V1SearchLogisticsStorageArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIStorageArticleSearchResponse> {
        const response = await this.v1SearchLogisticsStorageArticlesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for organizations
     */
    async v1SearchOrganizationsOrganizationsAutocompleteRetrieveRaw(requestParameters: V1SearchOrganizationsOrganizationsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOrganizationAutocompleteResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchOrganizationsOrganizationsAutocompleteRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/organizations/organizations/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOrganizationAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for organizations
     */
    async v1SearchOrganizationsOrganizationsAutocompleteRetrieve(requestParameters: V1SearchOrganizationsOrganizationsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOrganizationAutocompleteResponse> {
        const response = await this.v1SearchOrganizationsOrganizationsAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for organizations using Elasticsearch
     */
    async v1SearchOrganizationsOrganizationsRetrieveRaw(requestParameters: V1SearchOrganizationsOrganizationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOrganizationSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchOrganizationsOrganizationsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['city'] != null) {
            queryParameters['city'] = requestParameters['city'];
        }

        if (requestParameters['country'] != null) {
            queryParameters['country'] = requestParameters['country'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['hasBillingAddress'] != null) {
            queryParameters['has_billing_address'] = requestParameters['hasBillingAddress'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['rootAccountId'] != null) {
            queryParameters['root_account_id'] = requestParameters['rootAccountId'];
        }

        if (requestParameters['shippingCity'] != null) {
            queryParameters['shipping_city'] = requestParameters['shippingCity'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['vatNumber'] != null) {
            queryParameters['vat_number'] = requestParameters['vatNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/organizations/organizations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOrganizationSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for organizations using Elasticsearch
     */
    async v1SearchOrganizationsOrganizationsRetrieve(requestParameters: V1SearchOrganizationsOrganizationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOrganizationSearchResponse> {
        const response = await this.v1SearchOrganizationsOrganizationsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for employees
     */
    async v1SearchPersonnelEmployeesAutocompleteRetrieveRaw(requestParameters: V1SearchPersonnelEmployeesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIEmployeeAutocompleteResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchPersonnelEmployeesAutocompleteRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/personnel/employees/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIEmployeeAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for employees
     */
    async v1SearchPersonnelEmployeesAutocompleteRetrieve(requestParameters: V1SearchPersonnelEmployeesAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIEmployeeAutocompleteResponse> {
        const response = await this.v1SearchPersonnelEmployeesAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for employees using Elasticsearch
     */
    async v1SearchPersonnelEmployeesRetrieveRaw(requestParameters: V1SearchPersonnelEmployeesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIEmployeeSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchPersonnelEmployeesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['groupName'] != null) {
            queryParameters['group_name'] = requestParameters['groupName'];
        }

        if (requestParameters['hasUser'] != null) {
            queryParameters['has_user'] = requestParameters['hasUser'];
        }

        if (requestParameters['positionName'] != null) {
            queryParameters['position_name'] = requestParameters['positionName'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['userEmail'] != null) {
            queryParameters['user_email'] = requestParameters['userEmail'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['weekday'] != null) {
            queryParameters['weekday'] = requestParameters['weekday'];
        }

        if (requestParameters['workShift'] != null) {
            queryParameters['work_shift'] = requestParameters['workShift'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/personnel/employees/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIEmployeeSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for employees using Elasticsearch
     */
    async v1SearchPersonnelEmployeesRetrieve(requestParameters: V1SearchPersonnelEmployeesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIEmployeeSearchResponse> {
        const response = await this.v1SearchPersonnelEmployeesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for offer files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - offer_id: Filter by offer ID (optional) - request_id: Filter by request ID (optional) - request_certificate: Filter by request certificate (optional) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchRequestsOfferFilesRetrieveRaw(requestParameters: V1SearchRequestsOfferFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOfferFileSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchRequestsOfferFilesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['fileName'] != null) {
            queryParameters['file_name'] = requestParameters['fileName'];
        }

        if (requestParameters['fileSize'] != null) {
            queryParameters['file_size'] = requestParameters['fileSize'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['offerId'] != null) {
            queryParameters['offer_id'] = requestParameters['offerId'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['requestCertificate'] != null) {
            queryParameters['request_certificate'] = requestParameters['requestCertificate'];
        }

        if (requestParameters['requestId'] != null) {
            queryParameters['request_id'] = requestParameters['requestId'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['storedAt'] != null) {
            queryParameters['stored_at'] = (requestParameters['storedAt'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/requests/offer-files/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferFileSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for offer files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - offer_id: Filter by offer ID (optional) - request_id: Filter by request ID (optional) - request_certificate: Filter by request certificate (optional) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchRequestsOfferFilesRetrieve(requestParameters: V1SearchRequestsOfferFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOfferFileSearchResponse> {
        const response = await this.v1SearchRequestsOfferFilesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for offers using Elasticsearch  Query Parameters: - q: Search query string (required) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - status: Filter by status integer (optional) - offer_number: Filter by offer ID (optional) - request_number: Filter by request certificate (optional) - article: Filter by article name (optional) - article_number: Filter by article number (optional) - created_at: Filter by exact creation date (optional, format: YYYY-MM-DD) - last_modified_at: Filter by exact update date (optional, format: YYYY-MM-DD) - remarks: Search in remarks (optional)
     */
    async v1SearchRequestsOffersRetrieveRaw(requestParameters: V1SearchRequestsOffersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIOfferSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchRequestsOffersRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['article'] != null) {
            queryParameters['article'] = requestParameters['article'];
        }

        if (requestParameters['articleNumber'] != null) {
            queryParameters['article_number'] = requestParameters['articleNumber'];
        }

        if (requestParameters['createdAt'] != null) {
            queryParameters['created_at'] = (requestParameters['createdAt'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['editors'] != null) {
            queryParameters['editors'] = requestParameters['editors'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['lastModifiedAt'] != null) {
            queryParameters['last_modified_at'] = (requestParameters['lastModifiedAt'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['offerNumber'] != null) {
            queryParameters['offer_number'] = requestParameters['offerNumber'];
        }

        if (requestParameters['prices'] != null) {
            queryParameters['prices'] = requestParameters['prices'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['remarks'] != null) {
            queryParameters['remarks'] = requestParameters['remarks'];
        }

        if (requestParameters['requestNumber'] != null) {
            queryParameters['request_number'] = requestParameters['requestNumber'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/requests/offers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIOfferSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for offers using Elasticsearch  Query Parameters: - q: Search query string (required) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - status: Filter by status integer (optional) - offer_number: Filter by offer ID (optional) - request_number: Filter by request certificate (optional) - article: Filter by article name (optional) - article_number: Filter by article number (optional) - created_at: Filter by exact creation date (optional, format: YYYY-MM-DD) - last_modified_at: Filter by exact update date (optional, format: YYYY-MM-DD) - remarks: Search in remarks (optional)
     */
    async v1SearchRequestsOffersRetrieve(requestParameters: V1SearchRequestsOffersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIOfferSearchResponse> {
        const response = await this.v1SearchRequestsOffersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for request files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - request_id: Filter by request ID (optional) - request_certificate: Filter by request certificate (optional) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchRequestsRequestFilesRetrieveRaw(requestParameters: V1SearchRequestsRequestFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFileSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchRequestsRequestFilesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['fileName'] != null) {
            queryParameters['file_name'] = requestParameters['fileName'];
        }

        if (requestParameters['fileSize'] != null) {
            queryParameters['file_size'] = requestParameters['fileSize'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['requestCertificate'] != null) {
            queryParameters['request_certificate'] = requestParameters['requestCertificate'];
        }

        if (requestParameters['requestId'] != null) {
            queryParameters['request_id'] = requestParameters['requestId'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['storedAt'] != null) {
            queryParameters['stored_at'] = (requestParameters['storedAt'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/requests/request-files/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for request files using Elasticsearch  Query Parameters: - q: Search query string (required, use \'*\' to match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - request_id: Filter by request ID (optional) - request_certificate: Filter by request certificate (optional) - file_name: Filter by file name (optional, partial match) - stored_at: Filter by stored date (optional, format: YYYY-MM-DD) - file_size: Filter by file size. Supports bytes (e.g., \'10287\'), KB (e.g., \'10.05\' or \'10.05 KB\'), MB, GB, etc. Values without unit and < 1000 are interpreted as KB. (optional)
     */
    async v1SearchRequestsRequestFilesRetrieve(requestParameters: V1SearchRequestsRequestFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFileSearchResponse> {
        const response = await this.v1SearchRequestsRequestFilesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for request certificates, contacts or article numbers  Query Parameters: - q: Prefix to search for (required) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchRequestsRequestsAutocompleteRetrieveRaw(requestParameters: V1SearchRequestsRequestsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestAutocompleteResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchRequestsRequestsAutocompleteRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/requests/requests/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for request certificates, contacts or article numbers  Query Parameters: - q: Prefix to search for (required) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchRequestsRequestsAutocompleteRetrieve(requestParameters: V1SearchRequestsRequestsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestAutocompleteResponse> {
        const response = await this.v1SearchRequestsRequestsAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for requests using Elasticsearch  Query Parameters: - q: Search query string (required, use \"*\" for match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - status: Comma separated list of status values to filter (optional) - priority: Filter by priority boolean (optional) - is_temp: Filter drafts (optional) - contact_id: Filter by contact id (optional) - contact_email: Filter by contact email (optional) - article: Filter by article name (optional) - article_number: Filter by article number (optional) - request_number: Filter by request certificate/number (optional) - certificate: Filter by certificate (alternative to request_number) (optional) - created_by: Filter by creator/contact name (optional) - created_date: Filter by exact creation date (optional, format: YYYY-MM-DD) - updated_date: Filter by exact update date (optional, format: YYYY-MM-DD) - country: Filter by destination country (optional) - remarks: Filter by remarks text (optional) - description: Filter by description text (optional) - quantities: Filter by quantities (optional) - wish_date: Filter by exact wish date (optional, format: YYYY-MM-DD)
     */
    async v1SearchRequestsRequestsRetrieveRaw(requestParameters: V1SearchRequestsRequestsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchRequestsRequestsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['article'] != null) {
            queryParameters['article'] = requestParameters['article'];
        }

        if (requestParameters['articleNumber'] != null) {
            queryParameters['article_number'] = requestParameters['articleNumber'];
        }

        if (requestParameters['certificate'] != null) {
            queryParameters['certificate'] = requestParameters['certificate'];
        }

        if (requestParameters['contactEmail'] != null) {
            queryParameters['contact_email'] = requestParameters['contactEmail'];
        }

        if (requestParameters['contactId'] != null) {
            queryParameters['contact_id'] = requestParameters['contactId'];
        }

        if (requestParameters['country'] != null) {
            queryParameters['country'] = requestParameters['country'];
        }

        if (requestParameters['createdBy'] != null) {
            queryParameters['created_by'] = requestParameters['createdBy'];
        }

        if (requestParameters['createdDate'] != null) {
            queryParameters['created_date'] = (requestParameters['createdDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['description'] != null) {
            queryParameters['description'] = requestParameters['description'];
        }

        if (requestParameters['editors'] != null) {
            queryParameters['editors'] = requestParameters['editors'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['isTemp'] != null) {
            queryParameters['is_temp'] = requestParameters['isTemp'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['priority'] != null) {
            queryParameters['priority'] = requestParameters['priority'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['quantities'] != null) {
            queryParameters['quantities'] = requestParameters['quantities'];
        }

        if (requestParameters['remarks'] != null) {
            queryParameters['remarks'] = requestParameters['remarks'];
        }

        if (requestParameters['requestNumber'] != null) {
            queryParameters['request_number'] = requestParameters['requestNumber'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['updatedDate'] != null) {
            queryParameters['updated_date'] = (requestParameters['updatedDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['wishDate'] != null) {
            queryParameters['wish_date'] = (requestParameters['wishDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/requests/requests/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for requests using Elasticsearch  Query Parameters: - q: Search query string (required, use \"*\" for match all) - fields: Comma-separated list of fields to search in (optional) - size: Number of results to return (default: 20, max: 100) - from: Offset for pagination (default: 0) - status: Comma separated list of status values to filter (optional) - priority: Filter by priority boolean (optional) - is_temp: Filter drafts (optional) - contact_id: Filter by contact id (optional) - contact_email: Filter by contact email (optional) - article: Filter by article name (optional) - article_number: Filter by article number (optional) - request_number: Filter by request certificate/number (optional) - certificate: Filter by certificate (alternative to request_number) (optional) - created_by: Filter by creator/contact name (optional) - created_date: Filter by exact creation date (optional, format: YYYY-MM-DD) - updated_date: Filter by exact update date (optional, format: YYYY-MM-DD) - country: Filter by destination country (optional) - remarks: Filter by remarks text (optional) - description: Filter by description text (optional) - quantities: Filter by quantities (optional) - wish_date: Filter by exact wish date (optional, format: YYYY-MM-DD)
     */
    async v1SearchRequestsRequestsRetrieve(requestParameters: V1SearchRequestsRequestsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestSearchResponse> {
        const response = await this.v1SearchRequestsRequestsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for suppliers  Query Parameters: - q: Prefix to search for (optional, if empty returns recent suppliers) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchSuppliersSuppliersAutocompleteRetrieveRaw(requestParameters: V1SearchSuppliersSuppliersAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APISupplierAutocompleteResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/suppliers/suppliers/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APISupplierAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for suppliers  Query Parameters: - q: Prefix to search for (optional, if empty returns recent suppliers) - size: Number of suggestions to return (default: 5, max: 20)
     */
    async v1SearchSuppliersSuppliersAutocompleteRetrieve(requestParameters: V1SearchSuppliersSuppliersAutocompleteRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APISupplierAutocompleteResponse> {
        const response = await this.v1SearchSuppliersSuppliersAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for suppliers using Elasticsearch
     */
    async v1SearchSuppliersSuppliersRetrieveRaw(requestParameters: V1SearchSuppliersSuppliersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APISupplierSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchSuppliersSuppliersRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contactEmail'] != null) {
            queryParameters['contact_email'] = requestParameters['contactEmail'];
        }

        if (requestParameters['contactLanguage'] != null) {
            queryParameters['contact_language'] = requestParameters['contactLanguage'];
        }

        if (requestParameters['contactName'] != null) {
            queryParameters['contact_name'] = requestParameters['contactName'];
        }

        if (requestParameters['contactPhone'] != null) {
            queryParameters['contact_phone'] = requestParameters['contactPhone'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['ustId'] != null) {
            queryParameters['ust_id'] = requestParameters['ustId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/suppliers/suppliers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APISupplierSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for suppliers using Elasticsearch
     */
    async v1SearchSuppliersSuppliersRetrieve(requestParameters: V1SearchSuppliersSuppliersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APISupplierSearchResponse> {
        const response = await this.v1SearchSuppliersSuppliersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Autocomplete suggestions for support tickets
     */
    async v1SearchSupportTicketsAutocompleteRetrieveRaw(requestParameters: V1SearchSupportTicketsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APITicketAutocompleteResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchSupportTicketsAutocompleteRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/support/tickets/autocomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APITicketAutocompleteResponseFromJSON(jsonValue));
    }

    /**
     * Autocomplete suggestions for support tickets
     */
    async v1SearchSupportTicketsAutocompleteRetrieve(requestParameters: V1SearchSupportTicketsAutocompleteRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APITicketAutocompleteResponse> {
        const response = await this.v1SearchSupportTicketsAutocompleteRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for support tickets using Elasticsearch
     */
    async v1SearchSupportTicketsRetrieveRaw(requestParameters: V1SearchSupportTicketsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APITicketSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling v1SearchSupportTicketsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdFrom'] != null) {
            queryParameters['created_from'] = requestParameters['createdFrom'];
        }

        if (requestParameters['createdTo'] != null) {
            queryParameters['created_to'] = requestParameters['createdTo'];
        }

        if (requestParameters['fields'] != null) {
            queryParameters['fields'] = requestParameters['fields'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['shared'] != null) {
            queryParameters['shared'] = requestParameters['shared'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['userEmail'] != null) {
            queryParameters['user_email'] = requestParameters['userEmail'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/support/tickets/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APITicketSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for support tickets using Elasticsearch
     */
    async v1SearchSupportTicketsRetrieve(requestParameters: V1SearchSupportTicketsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APITicketSearchResponse> {
        const response = await this.v1SearchSupportTicketsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1SearchUnreadMarkReadCreateRaw(requestParameters: V1SearchUnreadMarkReadCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMarkReadResponse>> {
        if (requestParameters['aPIMarkReadRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIMarkReadRequestRequest',
                'Required parameter "aPIMarkReadRequestRequest" was null or undefined when calling v1SearchUnreadMarkReadCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/unread/mark-read/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIMarkReadRequestRequestToJSON(requestParameters['aPIMarkReadRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMarkReadResponseFromJSON(jsonValue));
    }

    /**
     */
    async v1SearchUnreadMarkReadCreate(requestParameters: V1SearchUnreadMarkReadCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMarkReadResponse> {
        const response = await this.v1SearchUnreadMarkReadCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1SearchUnreadOverviewRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIUnreadOverview>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search/unread/overview/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIUnreadOverviewFromJSON(jsonValue));
    }

    /**
     */
    async v1SearchUnreadOverviewRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIUnreadOverview> {
        const response = await this.v1SearchUnreadOverviewRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupplierSuppliersAddressesCompareVersionsCreateRaw(requestParameters: V1SupplierSuppliersAddressesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1SupplierSuppliersAddressesCompareVersionsCreate().'
            );
        }

        if (requestParameters['suppliersPk'] == null) {
            throw new runtime.RequiredError(
                'suppliersPk',
                'Required parameter "suppliersPk" was null or undefined when calling v1SupplierSuppliersAddressesCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPIAddressRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAddressRequest',
                'Required parameter "aPIAddressRequest" was null or undefined when calling v1SupplierSuppliersAddressesCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/supplier/suppliers/{suppliers_pk}/addresses/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"suppliers_pk"}}`, encodeURIComponent(String(requestParameters['suppliersPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAddressRequestToJSON(requestParameters['aPIAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupplierSuppliersAddressesCompareVersionsCreate(requestParameters: V1SupplierSuppliersAddressesCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1SupplierSuppliersAddressesCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupplierSuppliersAddressesRevertPartialUpdateRaw(requestParameters: V1SupplierSuppliersAddressesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1SupplierSuppliersAddressesRevertPartialUpdate().'
            );
        }

        if (requestParameters['suppliersPk'] == null) {
            throw new runtime.RequiredError(
                'suppliersPk',
                'Required parameter "suppliersPk" was null or undefined when calling v1SupplierSuppliersAddressesRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/supplier/suppliers/{suppliers_pk}/addresses/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"suppliers_pk"}}`, encodeURIComponent(String(requestParameters['suppliersPk']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedAddressRequestToJSON(requestParameters['aPIPatchedAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupplierSuppliersAddressesRevertPartialUpdate(requestParameters: V1SupplierSuppliersAddressesRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1SupplierSuppliersAddressesRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupplierSuppliersAddressesVersionsRetrieveRaw(requestParameters: V1SupplierSuppliersAddressesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1SupplierSuppliersAddressesVersionsRetrieve().'
            );
        }

        if (requestParameters['suppliersPk'] == null) {
            throw new runtime.RequiredError(
                'suppliersPk',
                'Required parameter "suppliersPk" was null or undefined when calling v1SupplierSuppliersAddressesVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/supplier/suppliers/{suppliers_pk}/addresses/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"suppliers_pk"}}`, encodeURIComponent(String(requestParameters['suppliersPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIAddressFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupplierSuppliersAddressesVersionsRetrieve(requestParameters: V1SupplierSuppliersAddressesVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIAddress> {
        const response = await this.v1SupplierSuppliersAddressesVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * return all articles that are supplied by the specified supplier
     */
    async v1SupplierSuppliersArticlesRetrieveRaw(requestParameters: V1SupplierSuppliersArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIArticle>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1SupplierSuppliersArticlesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/supplier/suppliers/{id}/articles/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIArticleFromJSON(jsonValue));
    }

    /**
     * return all articles that are supplied by the specified supplier
     */
    async v1SupplierSuppliersArticlesRetrieve(requestParameters: V1SupplierSuppliersArticlesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIArticle> {
        const response = await this.v1SupplierSuppliersArticlesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupportTicketsCompareVersionsCreateRaw(requestParameters: V1SupportTicketsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APITicket>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1SupportTicketsCompareVersionsCreate().'
            );
        }

        if (requestParameters['aPITicketRequest'] == null) {
            throw new runtime.RequiredError(
                'aPITicketRequest',
                'Required parameter "aPITicketRequest" was null or undefined when calling v1SupportTicketsCompareVersionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/support/tickets/{id}/compare_versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APITicketRequestToJSON(requestParameters['aPITicketRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APITicketFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupportTicketsCompareVersionsCreate(requestParameters: V1SupportTicketsCompareVersionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APITicket> {
        const response = await this.v1SupportTicketsCompareVersionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupportTicketsRevertPartialUpdateRaw(requestParameters: V1SupportTicketsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APITicket>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1SupportTicketsRevertPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/support/tickets/{id}/revert/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedTicketRequestToJSON(requestParameters['aPIPatchedTicketRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APITicketFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupportTicketsRevertPartialUpdate(requestParameters: V1SupportTicketsRevertPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APITicket> {
        const response = await this.v1SupportTicketsRevertPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupportTicketsVersionsRetrieveRaw(requestParameters: V1SupportTicketsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APITicket>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1SupportTicketsVersionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/support/tickets/{id}/versions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APITicketFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1SupportTicketsVersionsRetrieve(requestParameters: V1SupportTicketsVersionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APITicket> {
        const response = await this.v1SupportTicketsVersionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1UploadsCommitBulkCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/uploads/commit/bulk/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async v1UploadsCommitBulkCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1UploadsCommitBulkCreateRaw(initOverrides);
    }

    /**
     */
    async v1UploadsPresignBulkCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/uploads/presign/bulk/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async v1UploadsPresignBulkCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1UploadsPresignBulkCreateRaw(initOverrides);
    }

}
